import React from "react";
import $ from "jquery";
//import { Tooltip } from '../commonComponent/Tooltip';
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import { Badge } from "react-bootstrap";
import { ConVar } from "./ConfigVar";
import { ConURL } from "./ConfigURL";
import { httpGetRequest, httpPostReqReg } from '../action/httpRequests';
import config from "../commonComponent/config";
import NoLogo from "../img/no-image157x236.png";
import cookie from 'react-cookies';
import * as htmlToImage from 'html-to-image';
import { NotificationManager } from "react-notifications";
import graphDownload from '../assets/images/graph-download.png';

const graphCodeObj = ConVar.graphCodeObj;
export function isUBN(vval) {
  if (vval !== undefined && vval !== null && vval !== "" && vval !== "undefined") {
    return false;
  } else {
    return true;
  }
}

export function monthNumberName(label,sp) {
  var separation = (!isUBN(sp) ? sp : "-");
  if (label.indexOf("-") !== -1) {
    let monthNum = label.split("-")[1].replace(/\b0+/g, "");
    monthNum = parseInt(monthNum) - 1;
    const yearNum = label.split("-")[0];
    label = getMonthShortNameFromNumber(monthNum) + separation + yearNum;
  }
  return label;
}

export function  getLastMonthkpi(currentDate) {
  let lastMonth = new Date(currentDate);
  lastMonth.setMonth(lastMonth.getMonth() - 1);
  const year = lastMonth.getFullYear();
  const month = (lastMonth.getMonth() + 1).toString().padStart(2, '0');
  return year+"-"+month;
};

export function  getLastDatekpi(currentDate) {
  let date = new Date(currentDate);
      date.setDate(date.getDate()-1);     
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
    return year+"-"+month+"-"+day;
};

export function mdyFromTs(timestamp, sp) {
  sp = !isUBN(sp) ? sp : "-";
  if (!isNaN(timestamp)) {
    const dateTime = new Date(timestamp);
    const year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    const date =
      dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
    const df = month + sp + date + sp + year;
    return df;
  } else {
    return "";
  }
}

export function dmyFromTs(timestamp, sp) {
  if (!isNaN(timestamp)) {
    const dateTime = new Date(timestamp);
    const year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    const date =
      dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
    const df = date + sp + month + sp + year;
    return df;
  } else {
    return "";
  }
}

export function ymdFromTs(timestamp, sp) {
  if (!isNaN(timestamp)) {
    const dateTime = new Date(timestamp);
    const year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    const date =
      dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
    const df = year + sp + month + sp + date;
    return df;
  } else {
    return "";
  }
}

export function getLastMonthStr() {
  let now = new Date();
  let lastday = new Date(now.getFullYear(), now.getMonth(), 0);
  let firstday = new Date(lastday.getFullYear(), lastday.getMonth(), 1);
  let lastMonth = mmddyyFromUTCString(firstday,"/") + "-" + mmddyyFromUTCString(lastday,"/");
  return lastMonth;
}

export function getLastMonth() {  
  let now = new Date();
  let lastday = new Date(now.getFullYear(), now.getMonth(), 0);
  let firstday = new Date(lastday.getFullYear(), lastday.getMonth(), 1);
  let lastMonth = mmddyyFromUTCString(firstday,"-");
  return lastMonth;
}

export function getLastWeek() {
  let currentDate = new Date();
  let currentDay = currentDate.getDay();
  let adjustedDay = (currentDay + 6) % 7;
  let lastMonday = new Date(currentDate);
  lastMonday.setDate(currentDate.getDate() - adjustedDay - 7);
  let firstDateLastWeek = new Date(lastMonday);
  firstDateLastWeek.setDate(lastMonday.getDate());
  let lastWeekLastDate = new Date(firstDateLastWeek);
  lastWeekLastDate.setDate(firstDateLastWeek.getDate() + 6);
  lastWeekLastDate = mmddyyFromUTCString(lastWeekLastDate,"-");
  return lastWeekLastDate;
}

export function getLastDay() {
  let currentDate = new Date();
  let previousDay = new Date(currentDate);
  previousDay.setDate(currentDate.getDate() - 1);
  previousDay = mmddyyFromUTCString(previousDay,"-");
  return previousDay;
}

export function getCurrentMonthStr() {
  let now = new Date();
  let firstday = new Date(now.getFullYear(), now.getMonth(), 1);  
  let lastday = new Date(firstday.getFullYear(), firstday.getMonth() + 1, 0);;
  let lastMonth = mmddyyFromUTCString(firstday,"/") + "-" + mmddyyFromUTCString(lastday,"/");
  return lastMonth;
}

export function getLastWeekStr() {
    let today = new Date();  
    let day = today.getDay();
    let t = day-1;    
    let monday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - t - 7); //monday from last week
    let sunday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - t - 1); //sunday from last week
    let lastMonth = mmddyyFromUTCString(monday,"/") + "-" + mmddyyFromUTCString(sunday,"/");
    return lastMonth;
}

export function getLastQuarter() {
  let msObj = moment().subtract(1, "quarter").startOf("quarter");
  let meObj = moment().subtract(1, "quarter").endOf("quarter");

  let lastQSdate = msObj.format("MM/DD/YYYY");
  let lastQEdate = meObj.format("MM/DD/YYYY");
  return {
    qsDate: lastQSdate,
    qeDate: lastQEdate,
    qsDateStr: msObj.format("MMM YYYY"),
    qeDateStr: meObj.format("MMM YYYY"),
  };
}

export function getDateFromQuarter(year, quarter, firstDay) {
  var month = 0;
  var day = 0;
  if(firstDay) {
    if(quarter === "Q1") {
      month = 0;
    } else if(quarter === "Q2") {
      month = 3;
    } else if(quarter === "Q3") {
      month = 6;
    } else {
      month = 9;
    }
    day = new Date(year.getFullYear(),month,"01");
  } else {    
    if(quarter === "Q1") {
      month = 2;
    } else if(quarter === "Q2") {
      month = 5;
    } else if(quarter === "Q3") {
      month = 8;
    } else {
      month = 11;
    }
    day = new Date(year.getFullYear(),month+1,0);
  }
  return day/1000;
}

export function getLastMonths(n) {
  var m = [
    "",
    "Jan",
    "Feb",
    "Mar",
    "Aprl",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let months = [];
  let today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth();

  let i = 0;
  do {
    months.push(m[parseInt((month > 9 ? "" : "0") + month)] + "-" + year);
    if (month === 1 || month === '1' ) {
      month = 12;
      year--;
    } else {
      month--;
    }
    i++;
  } while (i < n);

  months = months.reverse();
  let monthStr = months.toString();
  monthStr = monthStr.replaceAll(",", ", ");
  return monthStr;
}

export function yyyymmFromTs(timestamp) {
  if (!isNaN(timestamp)) {
    const dateTime = new Date(timestamp);
    const year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    const df = year + "" + month;
    return df;
  } else {
    return "";
  }
}

export function yyyyFromTs(timestamp) {
  if (!isNaN(timestamp)) {
    const dateTime = new Date(timestamp);
    const year = dateTime.getFullYear();
    const df = year;
    return df;
  } else {
    return "";
  }
}

export const datetimeFromTimestamp = (timestamp,sp) => {
  let space = sp ? sp : "/";
  let dateTime = new Date(timestamp);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let date =
    dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
  let hour =
    dateTime.getHours() < 10 ? "0" + dateTime.getHours() : dateTime.getHours();
  let min =
    dateTime.getMinutes() < 10
      ? "0" + dateTime.getMinutes()
      : dateTime.getMinutes();
  let time = month + space + date + space + year + " " + hour + ":" + min;
  return time;
};

export function YearFromTimestamp(timestamp) {
  let dateTime = new Date(timestamp * 1000);
  let year = dateTime.getFullYear();
  let val = year;
  return val;
}

export const dateFromTimestamp = (timestamp) => {
  let dateTime = new Date(timestamp);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let date =
    dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
  let time = month + "-" + date + "-" + year;
  return time;
};

export const datetimeFromTimestampmmddyyyy = (timestamp) => {
  let dateTime = new Date(timestamp);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let date =
    dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
  let hour =
    dateTime.getHours() < 10 ? "0" + dateTime.getHours() : dateTime.getHours();
  let min =
    dateTime.getMinutes() < 10
      ? "0" + dateTime.getMinutes()
      : dateTime.getMinutes();
  let time = month + "-" + date + "-" + year + " " + hour + ":" + min;
  return time;
};

export const dateFromSecondsyyyymmdd = (timestamp) => {
  let dateTime = new Date(timestamp);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let date =
    dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
  // let hour =
  //   dateTime.getHours() < 10 ? "0" + dateTime.getHours() : dateTime.getHours();
  // let min =
  //   dateTime.getMinutes() < 10
  //     ? "0" + dateTime.getMinutes()
  //     : dateTime.getMinutes();
  let time = year + "-" + month + "-" + date;
  return time;
};

export const datetimeFromTimestampyyyymmdd = (timestamp) => {
  let dateTime = new Date(timestamp);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let date =
    dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
  let hour =
    dateTime.getHours() < 10 ? "0" + dateTime.getHours() : dateTime.getHours();
  let min =
    dateTime.getMinutes() < 10
      ? "0" + dateTime.getMinutes()
      : dateTime.getMinutes();
  let time = year + "-" + month + "-" + date + " " + hour + ":" + min;
  return time;
};

export const yearmonthFromUTCString = (dateString) => {
  //Thu Jul 01 2021 05:30:00 GMT+0530 (India Standard Time)
  let dateTime = new Date(dateString);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let val = year + "-" + month;
  return val;
};

export const yyyymmddFormat = (date) => {
  date = date.split("-").reverse().join("-");
  let year = date.slice(0, 5);
  let month = date.slice(5, 10).split("-").reverse().join("-");
  //yyyy + '-' + mm + '-' + dd;
  return year + month;
};

export const mmddyyFromUTCString = (dateString, sp) => {
  //Thu Jul 01 2021 05:30:00 GMT+0530 (India Standard Time)
  const _sp = !isUBN(sp) ? sp : "/";
  let dateTime = new Date(dateString);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  let date_ = dateTime.getDate();
  month = month < 10 ? "0" + month : month;
  date_ = date_ < 10 ? "0" + date_ : date_;
  let val = month + _sp + date_ + _sp + year;
  return val;
};

export const yyyymmddFromUTCString = (dateString, sp) => {
  //Thu Jul 01 2021 05:30:00 GMT+0530 (India Standard Time)
  const _sp = !isUBN(sp) ? sp : "/";
  let dateTime = typeof dateString === "string" && dateString.includes("-") && !dateString.includes("T")
    ? new Date(dateString.replace(/-/g, "/"))
    : new Date(dateString);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  let date_ = dateTime.getDate();
  month = month < 10 ? "0" + month : month;
  date_ = date_ < 10 ? "0" + date_ : date_;
  let val = year + _sp + month + _sp + date_ ;
  return val;
};

export const yyyymmFromUTCString = (dateString, sp) => {
  //Thu Jul 01 2021 05:30:00 GMT+0530 (India Standard Time)
  const _sp = !isUBN(sp) ? sp : "/";
  let dateTime = new Date(dateString);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  let date_ = dateTime.getDate();
  month = month < 10 ? "0" + month : month;
  let val = year + _sp + month ;
  return val;
};

export const mmddyyFromDateTimeString = (dateString, sp) => {
  //2021-12-07T18:53:49.649 (India Standard Time)

  let dateTime = new Date(dateString);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  let date_ = dateTime.getDate();
  month = month < 10 ? "0" + month : month;
  let val = month + "/" + date_ + "/" + year;
  return val;
};

export const mmyyFromDateString = (dateString) => {
  let dateTime = new Date(dateString);
  let year = dateTime.getFullYear();
  // let month = dateTime.getMonth() + 1;
  // month = month < 10 ? "0" + month : month;
  let val = getMonthNameFromNumber(dateTime) + " " + year;
  return val;
};

export const yearmonthFromUnixTimestamp = (timestamp) => {
  //yyyy-mm timestamp in sec
  let dateTime = new Date(timestamp * 1000);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let val = year + "-" + month;
  return val;
};

export const yearQuarterFromUnixTimestamp = (timestamp) => {
  let dateTime = new Date(timestamp * 1000);
  var m = Math.floor(dateTime.getMonth() / 3) + 1;
  var y = dateTime.getFullYear();
  return y+"-Q"+m;
};

export const yearmonthdateFromUnixTimestamp = (timestamp) => {
  
  let dateTime = new Date(timestamp * 1000);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  let date = dateTime.getDate();

  month = month < 10 ? "0" + month : month;
  date = date < 10 ? "0" + date : date;

  let val = year + "-" + month + "-" + date;
  return val;
}

export const yearmonthFromTimestamp = (timestamp) => {
  //yyyy-mm
  let dateTime = new Date(timestamp);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let val = year + "-" + month;
  return val;
};


export const mmyyyyFromTimestamp = (timestamp,sp) => {
  //yyyy-mm
  var separation = sp ? sp : "-";
  let dateTime = new Date(timestamp);
  let year = dateTime.getFullYear();
  let month = dateTime.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let val = month + separation + year;
  return val;
};

export function getMonthNameFromNumber(timestamp) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  if (!isNaN(timestamp)) {
    const dateTime = new Date(timestamp);
    const month = dateTime.getMonth();
    const monthName = monthNames[month];
    const df = monthName;
    return df;
  } else {
    return "";
  }
}
export function getFirstLastDateFromYYYYMM(date,first) {
  if(date) {
    if(first) {
      date = date+"-01";
    } else {
      date = new Date(date);
      date.setUTCHours(12, 0, 0, 0);
      date = new Date(date.getFullYear() , date.getMonth()+1 , 0);
      date = date/1000;
      date = yearmonthdateFromUnixTimestamp(date);
    }
  }
  return date;
}
export function getFirstLastDateFromQuarter(quarter,first) {
  let date = "";
  if(quarter) {
    let quarterArray = quarter.split("-");
    let quarterYear = quarterArray[0];
    let quarterstr = quarterArray[1];
    if(quarterstr === "Q1") {
      if(first) {
        date = quarterYear+"-01-01";
      } else {
        date = quarterYear+"-03-31";
      }
    } else if(quarterstr === "Q2") {
      if(first) {
        date = quarterYear+"-04-01";
      } else {
        date = quarterYear+"-06-30";
      }
    } else if(quarterstr === "Q3") {
      if(first) {
        date = quarterYear+"-07-01";
      } else {
        date = quarterYear+"-09-30";
      }
    } else if(quarterstr === "Q4") {
      if(first) {
        date = quarterYear+"-10-01";
      } else {
        date = quarterYear+"-12-31";
      }
    } else { 
      if(first) {
        date = quarterYear+"-01-01";
      } else {
        date = quarterYear+"-03-31";
      }
    }
  }  
  return date;
}


const Phase = {
  CAT: "CAT",
  MOD: "MOD",
  NR: "NR",
  REV: "REV",
  SHARE: "SHARE",
};
const Segment = {
  D: "D",
  R: "R",
};
export function getAllSelectedValues(values, type) {
  const val_arr = [];
  $.each(values, function (inx, val) {
    if (val || val === true || val === "true") {
      if (type === "phase") {

        Object.keys(Phase).forEach((keyName, i) => {
          if (keyName === inx) {
            val_arr.push(Phase[keyName]);
          }
        });

      } else if (type === "segment") {

        Object.keys(Segment).forEach((keyName, i) => {
          if (keyName === inx) {
            val_arr.push(Segment[keyName]);
          }
        });

      }
    }
  });
  return val_arr;
}

export function TSFromDateStr(str) {
  let date = new Date(str);
  const ts = Math.round(date.getTime() / 1000);
  return ts;
}
export const getTotalForSalesAndRebates = (val_arr) => {
  let totalAbsoluteValue_Qty = 0,
    totalAv_AWP = 0,
    total_obj = {};
  val_arr.forEach((data) => {
    totalAbsoluteValue_Qty += data.total_quantity;
    totalAv_AWP += data.total_awp;
  });
  total_obj.batch_number = "Total";
  total_obj.document_date = "";
  total_obj.gp_customer_number = "";
  total_obj.gp_document_id = "";
  total_obj.gp_item_description = "";
  total_obj.gp_po = "";
  total_obj.gp_sop_type = "";
  total_obj.invoice_credit_memo_code = "";
  total_obj.t_project_id = "";
  total_obj.total_awp = totalAv_AWP;
  total_obj.total_quantity = totalAbsoluteValue_Qty;
  total_obj.__typename = "total";
  return total_obj;
};

export const getTotalForManufAndFul = (val_arr) => {
  let totalGLmodified = 0,
    totalRevenueAV_modified = 0,
    total_obj = {};
  val_arr.forEach((data) => {
    totalGLmodified += data.total_gl;
    totalRevenueAV_modified += data.total_revenue;
  });
  total_obj.account_number = "";
  total_obj.batch_number = "Total";
  total_obj.document_date = "";
  total_obj.gp_dta_group_id = "";
  total_obj.je_reference = "";
  total_obj.mda_code = "";
  total_obj.reference = "";
  total_obj.total_gl = totalGLmodified;
  total_obj.total_revenue = totalRevenueAV_modified;
  total_obj.unique_id = "";
  total_obj.__typename = "Statement";
  return total_obj;
};

export const getTotalForStudioSummary = (val_arr) => {
  let totalGross = 0,
    totalReturns = 0,
    totalRR = 0,
    totalNetSales = 0,
    totalFees = 0,
    totalRebates = 0,
    totalFreight = 0,
    totalManuf = 0,
    totalNetRevenue = 0,
    total_obj = {};
  val_arr.forEach((data) => {
    data.transactions.forEach((transaction) => {
      if (transaction.gl_desc === "Sales") {
        totalGross += parseFloat(transaction.revenue);
      }
      if (transaction.gl_desc === "Returns") {
        totalReturns += parseFloat(transaction.revenue);
      }
      if (transaction.gl_desc === "Net Sales") {
        totalNetSales += parseFloat(transaction.revenue);
      }
      if (transaction.gl_desc === "ServiceFees") {
        totalFees += parseFloat(transaction.revenue);
      }
      if (transaction.gl_desc === "Rebates") {
        totalRebates += parseFloat(transaction.revenue);
      }
      if (transaction.gl_desc === "Freight") {
        totalFreight += parseFloat(transaction.revenue);
      }
      if (transaction.gl_desc === "Manufacturing") {
        totalManuf += parseFloat(transaction.revenue);
      }
      if (transaction.gl_desc === "Net Revenue") {
        totalNetRevenue += parseFloat(transaction.revenue);
      }
    });
  });
  totalRR = (totalReturns / totalGross) * 100;
  total_obj.studio = "Total";
  let transactions = [],
    obj1 = {},
    obj2 = {},
    obj3 = {},
    obj4 = {},
    obj5 = {},
    obj6 = {},
    obj7 = {},
    obj8 = {},
    obj9 = {};
  obj1.gl_desc = "Returns";
  obj1.revenue = totalReturns;
  obj1.__typename = "Transaction";
  obj2.gl_desc = "Freight";
  obj2.revenue = totalFreight;
  obj2.__typename = "Transaction";
  obj3.gl_desc = "Rebates";
  obj3.revenue = totalRebates;
  obj3.__typename = "Transaction";
  obj4.gl_desc = "Sales";
  obj4.revenue = totalGross;
  obj4.__typename = "Transaction";
  obj5.gl_desc = "Net Sales";
  obj5.revenue = totalNetSales;
  obj5.__typename = "Transaction";
  obj6.gl_desc = "RR%";
  obj6.revenue = totalRR;
  obj6.__typename = "Transaction";
  obj7.gl_desc = "Net Revenue";
  obj7.revenue = totalNetRevenue;
  obj7.__typename = "Transaction";
  obj8.gl_desc = "Manufacturing";
  obj8.revenue = totalManuf;
  obj8.__typename = "Transaction";
  obj9.gl_desc = "ServiceFees";
  obj9.revenue = totalFees;
  obj9.__typename = "Transaction";
  transactions.push(obj1);
  transactions.push(obj2);
  transactions.push(obj3);
  transactions.push(obj4);
  transactions.push(obj5);
  transactions.push(obj6);
  transactions.push(obj7);
  transactions.push(obj8);
  transactions.push(obj9);
  total_obj.transactions = transactions;
  total_obj.__typename = "Studio";
  return total_obj;
};

export const getTotalForMonthlySalesbyTitle = (val_arr) => {
  let totalGrsQty = 0,
    totalRetQty = 0,
    totalNetQty = 0,
    totalGrs = 0,
    totalRet = 0,
    totalNet = 0,
    total_obj = {};
  val_arr.forEach((data) => {
    totalGrsQty += data.gross_qty;
    totalRetQty += data.return_qty;
    totalNetQty += data.net_qty;
    totalGrs += data.gross_revenue;
    totalRet += data.return_revenue;
    totalNet += data.net_revenue;
  });
  total_obj.format = "";
  total_obj.gross_qty = totalGrsQty;
  total_obj.gross_revenue = totalGrs;
  total_obj.inventory_name = "";
  total_obj.item_class = "";
  total_obj.item_subclass = "";
  total_obj.mda_code = "";
  total_obj.month_end = "Total";
  total_obj.net_qty = totalNetQty;
  total_obj.net_revenue = totalNet;
  total_obj.producer = "";
  total_obj.product_id = "";
  total_obj.retailer_id = "";
  total_obj.retailer_name = "";
  total_obj.retailer_type = "";
  total_obj.return_qty = totalRetQty;
  total_obj.return_revenue = totalRet;
  total_obj.street_date = "";
  total_obj.sub_studio = "";
  total_obj.t_project_id = "";
  total_obj.upc = "";
  total_obj.__typename = "DocumentFin";
  return total_obj;
};

export const getAbsentInRlData = (val_arr, type) => {
  let rebates_data = [];
  val_arr.forEach((data) => {
    let rebates_obj = {};
    if (data.gp_customer_description === type) {
      rebates_obj.product_id = data.product_id;
      rebates_obj.tin = data.tin;
      rebates_obj.title = data.title;
      rebates_obj.upc = data.upc;
      rebates_data.push(rebates_obj);
    }
  });
  return rebates_data;
};

export const GetAssetTypeIcons = (atype, id, position) => {
  if (!isUBN(atype)) {
    var _position = !isUBN(position) ? position : "right";
    if (atype === "season") {
      return (
        <Tooltip id={id} title={"Season"} arrow placement={_position}>
          <i className="icon-season" style={{ fontSize: 14 }}></i>
        </Tooltip>
      );
    } else if (atype === "episodic" || atype === "series") {
      return (
        <Tooltip id={id} title={"Series"} arrow placement={_position}>
          <i className="icon-series " style={{ fontSize: 14 }}></i>
        </Tooltip>
      );
    } else if (atype === "vod" || atype === "film") {
      return (
        <Tooltip id={id} title={"Film"} arrow placement={_position}>
          <i className="icon-film " style={{ fontSize: 14 }}></i>
        </Tooltip>
      );
    } else if (atype === "episode") {
      return (
        <Tooltip id={id} title={"Episode"} arrow placement={_position}>
          <i className="icon-episode " style={{ fontSize: 14 }}></i>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip id={id} title={"Unknown"} arrow placement={_position}>
          <i className="icon-unknown " style={{ fontSize: 14 }}></i>
        </Tooltip>
      );
    }
  }
};

export const GetTypeIcons = (id, val, msg, position) => {
  if (!isUBN(val)) {
    var _position = !isUBN(position) ? position : "right";
    var _msg = !isUBN(msg) ? msg : "";
    _msg = _msg.replace(/"/g, " ");
    _msg = _msg.replace(/'/g, " ");
    _msg = _msg.replace(/,/g, " ");
    if (val === 0 || val === '0') {
      _msg = !isUBN(_msg) ? _msg : "Initialize";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-initialization clr-initialize"></i>
        </Tooltip>
      );
    } else if (val < 0) {
      if (val === "-11" || val === "-20" || val === "-101" || val === "-13") {
        _msg = !isUBN(_msg) ? _msg : "Error";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-error clr-error"></i>
          </Tooltip>
        );
      } else if (val === "-3" || val === "-2") {
        _msg = !isUBN(_msg) ? _msg : "Error"; //for now only  Error but it will be Rights Error
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-rights-error clr-error"></i>
          </Tooltip>
        );
      } else if (val <= "-50" && val >= "-60") {
        _msg = !isUBN(_msg) ? _msg : "Error"; //for ignored items
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-error clr-error"></i>
          </Tooltip>
        );
      } else {
        _msg = !isUBN(_msg) ? _msg : "Error";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-error clr-danger"></i>
          </Tooltip>
        );
      }
    } else if (val > 1 && val < 10) {
      _msg = !isUBN(_msg) ? _msg : "Processing";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-processing-new clr-warningOrange"></i>
        </Tooltip>
      );
    } else if (val === 1 || val === '1' ) {
      _msg = !isUBN(_msg) ? _msg : "Scheduled";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-completed clr-complete"></i>
        </Tooltip>
      );
    } else if (val >= 10) {
      if (val === 20 || val === '20') {
        _msg = !isUBN(_msg) ? _msg : "Active with pending task";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-completed clr-successDark"></i>
          </Tooltip>
        );
      } else if (val === 30) {
        _msg = !isUBN(_msg) ? _msg : "Active with running task";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-completed clr-successDarker"></i>
          </Tooltip>
        );
      } else {
        _msg = !isUBN(_msg) ? _msg : "Completed";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-completed clr-success"></i>
          </Tooltip>
        );
      }
    } else {
      return "";
    }
  }
};

export const getAbsoluteValuesCalculationData = (val_arr) => {
  let absolute_data = [];
  val_arr.forEach((data) => {
    let absolute_obj = {};
    if (data.gp_dta_group_id === "Total") {
      absolute_obj.invoice_revenue = data.invoice_revenue;
      absolute_obj.net_revenue = data.net_revenue;
      absolute_obj.return_revenue = data.return_revenue;
      absolute_obj.revenue_modulus = data.revenue_modulus;
      absolute_data.push(absolute_obj);
    }
  });
  return absolute_data;
};

export const valueToDollarFormat = (val, decPlace) => {
  if (!isUBN(val)) {
    let newVal = "",
      num_val = parseFloat(val);
    if (num_val >= 0) {
      newVal = num_val.toLocaleString("en-US", {
        maximumFractionDigits: (!isUBN(decPlace) ? decPlace : 2),
        minimumFractionDigits: (!isUBN(decPlace) ? decPlace : 2),
        style: "currency",
        currency: "USD",
      });
    } else {
      let value = Math.abs(num_val);
      newVal = value.toLocaleString("en-US", {
        maximumFractionDigits: (!isUBN(decPlace) ? decPlace : 2),
        minimumFractionDigits: (!isUBN(decPlace) ? decPlace : 2),
        style: "currency",
        currency: "USD",
      });
      newVal = "(" + newVal + ")";
    }
    return newVal;
  } else {
    return "";
  }
};

export const USFormat = (val) => {
  if (!isUBN(val)) {
    let newVal = "",
      num_val = parseFloat(val);
    newVal = num_val.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    return newVal;
  } else {
    return "";
  }
};

export const USFormatWithoutDecimal = (val) => {
  if (!isUBN(val)) {
    let newVal = "",
      num_val = parseInt(val);
    newVal = num_val.toLocaleString("en-US");
    return newVal;
  } else {
    return "";
  }
};

export const numbersToUSFormat = (val,decplace) => {
  if (!isUBN(val)) {
    let newVal = "",
      num_val = parseFloat(val);
    if (num_val >= 0) {
      newVal = num_val.toLocaleString("en-US", {
        maximumFractionDigits: decplace ? decplace : 2,
        minimumFractionDigits: decplace ? decplace : 2,
      });
    } else {
      newVal = num_val.toLocaleString("en-US", {
        maximumFractionDigits: decplace ? decplace : 2,
        minimumFractionDigits: decplace ? decplace : 2,
      });
      newVal = "(" + newVal + ")";
    }
    return newVal;
  } else {
    return "";
  }
};

export const valueFormat = (val) => {
  let num_val = parseFloat(val);
  if (num_val >= 0) {
    return Math.round(num_val * 100) / 100;
  } else {
    return "(" + Math.round(Math.abs(num_val) * 100) / 100 + ")";
  }
};

export const valueAVAWPFormat = (val) => {
  let num_val = parseFloat(val);
  if (num_val >= 0) {
    return Math.round(num_val * 100000) / 100000;
  } else {
    return "(" + Math.round(Math.abs(num_val) * 100000) / 100000 + ")";
  }
};

export const numberAlignedRight = (val) => {
  return <div style={{ textAlign: "right" }}>{val}</div>;
};

export const finalTprojectValueFormat = (value) => {
  if (!isUBN(value)) {
    let val_arr = [];
    if (value.trim().indexOf(",") !== -1) {
      val_arr = value.trim().split(",");
      return val_arr.forEach((data, index) => (
        <span key={index}>
          {val_arr[index].trim()}
          <br />
        </span>
      ));
    } else if (value.trim().indexOf("|") !== -1) {
      val_arr = value.trim().split("|");
      return val_arr.forEach((data, index) => (
        <span key={index}>
          {val_arr[index].trim()}
          <br />
        </span>
      ));
    } else {
      return value;
    }
  } else {
    return "";
  }
};
export const statusIconsMsg = (id, val, msg, position) => {
  val = parseInt(val);
  let _msg = "";
  let iconcls = "icon-initialization clr-initialize";
  if (val < 0) {
    _msg = "Error";
    iconcls = "icon-error clr-danger";
  } else if (val === 0) {
    _msg = "Initialise";
    iconcls = "icon-initialization";
  } else if (val === 5) {
    _msg = "Processing";
    iconcls = "icon-processing-new clr-warningOrange";
  } else if (val >= 10) {
    _msg = "Completed";
    iconcls = "icon-completed clr-successDark";
  }
  if (msg && msg.trim().length > 0) {
    _msg = msg;
  }
  let _position = position ? position : "right";
  return (
    <Tooltip id={id} title={_msg} arrow placement={_position}>
      <i className={iconcls}></i>
    </Tooltip>
  );
};
export const levelToStatus = (level,statusFor) =>
{
  var status = '';
  if (!isUBN(level)) {   
    if (level === 0) {
      status =  "init";
    } else if (level < 0) {
        status = "error";
    } else {
      status = "completed";
    } 
  }
  return status;
}

export const statusIcons = (id, val, msg, position, statusFor,agg_status) => {
  val = parseInt(val);
  if (!isUBN(val)) {
    var _position = !isUBN(position) ? position : "right";
    var _msg = !isUBN(msg) ? msg : "";
    _msg = _msg.replace(/"/g, " ");
    _msg = _msg.replace(/'/g, " ");
    _msg = _msg.replace(/,/g, " ");
    if (val === 0) {
      _msg = !isUBN(_msg) ? _msg : "Initialize";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-initialization clr-initialize"></i>
        </Tooltip>
      );
    } else if (val < 0) {
      if(statusFor === "batch-reports" && (val === -50 || val === '-50')) {
        _msg = !isUBN(_msg) ? _msg : "Ignored";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-rights-error clr-error"></i>
          </Tooltip>
        );
      }
      if(statusFor === "batch-reports" ) {
        _msg = !isUBN(_msg) ? _msg : "Error";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-error clr-danger"></i>
          </Tooltip>
        );
      }
      if((val === -43 || val === '-43')) {
        _msg = !isUBN(_msg) ? _msg : "Unavailable";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-rights-error clr-inactive"></i>
          </Tooltip>
        );
      }
      if((statusFor === "partner-channel-revenue" || statusFor === 'quarterly-revenue') && (val === -5 || val === '-5' || val === -6 || val === '-6')) {
        _msg = !isUBN(_msg) ? _msg : "Copied from ad Revenue";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-error clr-error"></i>
          </Tooltip>
        );
      } else if(val === "-50" || val === -50){
        if(statusFor === "ingest") {
          if(agg_status === "3" || agg_status === 3 || agg_status === "0" || agg_status === 0) {
             _msg = !isUBN(_msg) ? _msg : "Processing";
            return (
              <Tooltip id={id} title={_msg} arrow placement={_position}>
                <i className="icon-processing-new clr-warningOrange"></i>
              </Tooltip>
            );
          } else {
              _msg = !isUBN(_msg) ? _msg : "Ignored";
            return (
              <Tooltip id={id} title={_msg} arrow placement={_position}>
                <i className="icon-rights-error clr-error"></i>
              </Tooltip>
            );
          }
        } else {
          _msg = !isUBN(_msg) ? _msg : "Ignored";
          return (
            <Tooltip id={id} title={_msg} arrow placement={_position}>
              <i className="icon-rights-error clr-error"></i>
            </Tooltip>
          );
        }        
      }else if(val === "-52" || val === -52 || val === "-51" || val === -51){
        _msg = !isUBN(_msg) ? _msg : "Error";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="fa fa-times-circle clr-danger font-17"></i>
          </Tooltip>
        );
      }else if(val === "-71" || val === -71){
        _msg = !isUBN(_msg) ? _msg : "Archive";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="feather icon-status-archive"></i>
          </Tooltip>
        );
      }else if(val === "-10" || val === -10){
        _msg = !isUBN(_msg) ? _msg : "Deactivated";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="feather icon-completed"></i>
          </Tooltip>
        );
      }else if(val === "-5" || val === -5){
        if(statusFor === "ingest") {
          if(agg_status === "3" || agg_status === 3 || agg_status === "0" || agg_status === 0) {
             _msg = !isUBN(_msg) ? _msg : "Processing";
            return (
              <Tooltip id={id} title={_msg} arrow placement={_position}>
                <i className="icon-processing-new clr-warningOrange"></i>
              </Tooltip>
            );
          } else {      
            _msg = !isUBN(_msg) ? _msg : "Error";
            return (
              <Tooltip id={id} title={_msg} arrow placement={_position}>
                <i className="icon-error clr-danger"></i>
              </Tooltip>
            );
          }
        } else {
          _msg = !isUBN(_msg) ? _msg : "Error";
          return (
            <Tooltip id={id} title={_msg} arrow placement={_position}>
              <i className="icon-error clr-danger"></i>
            </Tooltip>
          );
        }
      }else {
        _msg = !isUBN(_msg) ? _msg : "Error";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-error clr-danger"></i>
          </Tooltip>
        );
      }
    } else if (val > 1 && val < 10) {
      if(statusFor === "amazon-id-map" && val === 5){
        _msg = !isUBN(_msg) ? _msg : "Pending";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-hourglass-new clr-pending"></i>
          </Tooltip>
        );
      }else{
        _msg = !isUBN(_msg) ? _msg : "Processing";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-processing-new clr-warningOrange"></i>
          </Tooltip>
        );
      }
    } else if (val === 1) {
      _msg = !isUBN(_msg) ? _msg : "Scheduled";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-completed clr-complete"></i>
        </Tooltip>
      );
    } else if (val === 200) {
      _msg = !isUBN(_msg) ? _msg : "Finalized";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-finalizeStatus clr-finalize"></i>
        </Tooltip>
      );
    } else if (val >= 10) {
      if(statusFor === "amazon-id-map" && val === 16){
        _msg = !isUBN(_msg) ? _msg : "Ignored";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-ignore clr-warningOrange"></i>
          </Tooltip>
        );
      }else if((statusFor === "partner-id-map" || statusFor === "supply-router-map") && val === 15){
        _msg = !isUBN(_msg) ? _msg : "Pending";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-hourglass-new clr-pending"></i>
          </Tooltip>
        );
      }else if (statusFor === "ad-channel-map" && val === 15) {
        _msg = !isUBN(_msg) ? _msg : "Marked as audience extension";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-completed clr-successDarker"></i>
          </Tooltip>
        );
      }else if ((statusFor !== "amazon-id-map" && statusFor !== "ad-channel-map") && val === 15) {
        _msg = !isUBN(_msg) ? _msg : "Ignored";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-ignore clr-warningOrange"></i>
          </Tooltip>
        );
      }else if (val === 20) {
        _msg = !isUBN(_msg) ? _msg : "Active with pending task";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-completed clr-successDark"></i>
          </Tooltip>
        );
      } else if (val === 30) {
        _msg = !isUBN(_msg) ? _msg : "Active with running task";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-completed clr-successDarker"></i>
          </Tooltip>
        );
      } else if (val === 12) {
        _msg = !isUBN(_msg) ? _msg : "Completed";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-error clr-successDarker"></i>
          </Tooltip>
        );
      }  else if (val === 10) {
        if(statusFor === "ingest") {
          if(agg_status === "3" || agg_status === 3 || agg_status === "0" || agg_status === 0) {
             _msg = !isUBN(_msg) ? _msg : "Processing";
            return (
              <Tooltip id={id} title={_msg} arrow placement={_position}>
                <i className="icon-processing-new clr-warningOrange"></i>
              </Tooltip>
            );
          } else {
            _msg = !isUBN(_msg) ? _msg : "Completed";
            return (
              <Tooltip id={id} title={_msg} arrow placement={_position}>
                <i className="icon-completed clr-success"></i>
              </Tooltip>
            );
          }
        } else {
          _msg = !isUBN(_msg) ? _msg : "Completed";
          return (
            <Tooltip id={id} title={_msg} arrow placement={_position}>
              <i className="icon-completed clr-success"></i>
            </Tooltip>
          );
        }
      } else {
        _msg = !isUBN(_msg) ? _msg : "Completed";
        return (
          <Tooltip id={id} title={_msg} arrow placement={_position}>
            <i className="icon-completed clr-success"></i>
          </Tooltip>
        );
      }
    } else {
      return "";
    }
  }
};

export const statusIconsTemplate = (id, val) => {
  val = parseInt(val);
  if (!isUBN(val)) {
    var _position = "right";
    var _msg = "";
    if (val === 0) {
      _msg = "Created";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-create"></i>
        </Tooltip>
      );
    } else if (val === 10) {
      _msg = "In Use";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="icon-completed clr-success"></i>
        </Tooltip>
      );
    } else if (val === -55) {
      _msg = "Deleted";
      return (
        <Tooltip id={id} title={_msg} arrow placement={_position}>
          <i className="fa fa-times-circle clr-danger font-17"></i>
        </Tooltip>
      );
    } else {
      return "";
    }
  }
};

export const coloredStatus = (val) => {
  let _status = "",
    _cls = "",
    _txt = "";
  if (!isUBN(val)) {
    // if (val == 0) {
    //     _cls = 'clr-initialize';
    //     _txt = 'Initialize';
    // }else if (val < 0) {
    //     _cls = 'clr-error';
    //     _txt = 'Error';
    // }else if(val>1 && val<10){
    //     _cls = 'clr-warning';
    //     _txt = 'Processing';
    // }else if(val == 1){
    //     _cls = 'clr-complete';
    //     _txt = 'Scheduled';
    // }else if (val >= 10) {
    //     _cls = 'clr-success';
    //     _txt = 'Completed';
    // }
    if (val.toUpperCase() === "ERROR") {
      _cls = "clr-error";
      _txt = "ERROR";
    } else if (val.toUpperCase() === "WARNING") {
      _cls = "clr-warning";
      _txt = "WARNING";
    } else if (val.toUpperCase() === "OK") {
      _cls = "clr-success";
      _txt = "OK";
    }
    _status = (
      <>
        {_txt === "WARNING" ? (
          <>
            <span className={_cls}>{_txt}</span>&nbsp;
            {/* <form className="upload-button" style={{marginBottom:5,marginTop:4}} name="edit-profilepic-form" id="edit-profilepic-form" encType="multipart/form-data">
                <figcaption><i className="fa fa-download" aria-hidden="true" style={{fontSize: 10}}></i></figcaption>
                <input type="file" id="file_profimg" className="item-img file center-block" />
            </form> */}
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              id="contained-button-file"
            />
            <label htmlFor="contained-button-file">
              {/* <i className="fa fa-download" aria-hidden="true" style={{fontSize: 10}}></i> */}
            </label>
          </>
        ) : (
          <span className={_cls}>{_txt}</span>
        )}
      </>
    );
  }
  return _status;
};

export const decimalFixedToTwo = (number) => {
  if (!isUBN(number)) {
    return parseFloat(number).toFixed(2);
  } else {
    return "";
  }
};
export const decimalFixedToNum = (number, decPlace) => {
  if (!isUBN(number)) {
    return parseFloat(number).toFixed(decPlace);
  } else {
    return "";
  }
};
export const usNumFormat = (number) => {
  if (!isUBN(number)) {
    let formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
  } else {
    return "";
  }
};

export const getRandomColorCode = (_color, _len) => {
  // const letters = "0123456789ABCDEF".split("");
  // let color = "#";
  // for (let i = 0; i < 6; i++) {
  //   color += letters[Math.floor(Math.random() * 16)];
  // }
  // return color;

  // console.log(_color);
  // const rgb = _color.substring(4, _color.length-1)
  //        .replace(/ /g, '')
  //        .split(',');
  // var r = parseInt(rgb[0]);
  // var g = parseInt(rgb[1]);
  // var b = parseInt(rgb[2]);
  // var result = [];

  // // r += 33;
  // // g += 33;
  // // b += 33;
  // // result = "rgb(" + r + "," + g + "," + b +")";

  // var max = Math.max(Math.max(r, Math.max(g,b)), 1);

  // var step = 255 / (max * 10)
  // for(var i = 1; i <= _len; i++)
  // {
  //     r += 33;
  //     g += 33;
  //     b += 33;
  //     // result.push("rgb(" + r * step * i  + "," + g * step * i + "," + b * step * i +")");
  //     // result.push("rgb(" + ((r * i) / 10)  + "," + ((g * i) / 10) + "," + ((b * i) / 10) +")");
  //     result.push("rgb(" + r  + "," + g + "," + b +")");
  // }
  
  // console.log(result);
  // return (
  //   result
  // );
  var o = Math.round,
    r = Math.random,
    s = 255;
  return (
    "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + "," + 0.63 + ")"
  );
};

export const getMonthShortNameFromNumber = (month) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthShortName = monthNames[month];
  return monthShortName;
};

export const valueFormatForMoney = (value) => {
  const mValue =
    Math.abs(Number(value)) >= 1.0e9
      ? Math.abs(Number(value)) / 1.0e9 + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(value)) >= 1.0e6
      ? Math.abs(Number(value)) / 1.0e6 + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(value)) >= 1.0e3
      ? Math.abs(Number(value)) / 1.0e3 + "K"
      : Math.abs(Number(value));
  return mValue;
};

export const valueFormatForMoneyDecimalFixedToTwo = (value) => {
  const mValue =
    Math.abs(Number(value)) >= 1.0e9
      ? decimalFixedToTwo(Math.abs(Number(value)) / 1.0e9) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(value)) >= 1.0e6
      ? decimalFixedToTwo(Math.abs(Number(value)) / 1.0e6) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(value)) >= 1.0e3
      ? decimalFixedToTwo(Math.abs(Number(value)) / 1.0e3) + "K"
      : decimalFixedToTwo(Math.abs(Number(value)));
  return mValue;
};

export const valueFormatForMoneyDecimalFixedToNum = (value, decPlace) => {
  const mValue =
    Math.abs(Number(value)) >= 1.0e9
      ? decimalFixedToNum(Math.abs(Number(value)) / 1.0e9, decPlace) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(value)) >= 1.0e6
      ? decimalFixedToNum(Math.abs(Number(value)) / 1.0e6, decPlace) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(value)) >= 1.0e3
      ? decimalFixedToNum(Math.abs(Number(value)) / 1.0e3, decPlace) + "K"
      : decimalFixedToNum(Math.abs(Number(value)), decPlace);
  return mValue;
};

export const valueFormatWithoutDecimal = (value) => {
  const mValue =
    Math.abs(Number(value)) >= 1.0e9
      ? Math.abs(Number(value)) / 1.0e9 + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(value)) >= 1.0e6
      ? Math.abs(Number(value)) / 1.0e6 + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(value)) >= 1.0e3
      ? Math.abs(Number(value)) / 1.0e3 + "K"
      : Math.abs(Number(value));
  return mValue;
};

export const getBadgeColor = (value) => {
  let badgeVariant = value > 0 ? "success" : value < 0 ? "danger" : "secondary";
  return badgeVariant;
};
export const getYoyIcon = (value) => {
  let yoyIcon =
    value > 0 ? "fa fa-arrow-up" : value < 0 ? "fa fa-arrow-down" : "";
  return yoyIcon;
};
export const getLabelColor = (value) => {
  let color_cls =
    value > 0 ? "green-label" : value < 0 ? "red-label" : "gray-label";
  return color_cls;
};
export const getLabelColorCost = (value) => {
  let color_cls =
    value < 0 ? "green-label" : value > 0 ? "red-label" : "gray-label";
  return color_cls;
};
export const getLabelIcon = (value) => {
  let yoyIcon =
    value > 0 ? "value-change-arrow feather icon-up-arrow-new" : value < 0 ? "value-change-arrow feather icon-down-arrow-new" : "";
  return yoyIcon;
};

export const capitalizeFirstLetter = (string) => {
  if(isUBN(string))  {
    return '';
  }
  return (string && (typeof string === 'string') ? string.charAt(0).toUpperCase() + string.slice(1) : '');
};

export const formatReportHeader = (value) => {
  if (!isUBN(value) && value.indexOf("_") !== -1) {
    let _arr = value.split("_");
    let _val = "";
    _arr.forEach((val) => {
      if(val === "id"){
        _val += val.toUpperCase() + " ";
      }else{
        _val += capitalizeFirstLetter(val) + " ";
      }
    });
    return _val;
  } else {
    return !isUBN(value) ? capitalizeFirstLetter(value) : ""; 
  }
};

export const formatGraphDropdown = (value) => {
  if (value.indexOf("_") !== -1) {
    let _arr = value.split("_");
    let _val = "";
    _arr.forEach((val) => {
      if (val !== "ad") _val += val + " ";
    });
    return capitalizeFirstLetter(_val);
  }
  return capitalizeFirstLetter(value);
};
export const truncateMidString = (str, len_) => {
  if (!str || (str && str.length === 0)) {
    return "";
  }
  let firstChars = str && str.substring(0, len_ ? len_ : 5);
  let lastChars = str && str.slice(-6);
  return firstChars + "..." + lastChars;
};
export const truncateLicensorName = (str,len_) => {
  if (!str || (str && str.length === 0)) {
    return "";
  } 
  let firstChars = str && str.substring(0, len_ ? len_ : 5);
  return firstChars;
}

export const dateFilterValue = (value) => {
  let cdate = new Date();
  let pmon = cdate.getMonth();
  let pmon_yr =
    cdate.getFullYear() + "-" + (pmon < 10 ? "0" + pmon : pmon) + "-01";
  let fdate = new Date(pmon_yr);
  let fdatefrom = fdate.getTime();
  let fdateto = new Date(
    fdate.getFullYear(),
    fdate.getMonth() + 1,
    1
  ).getTime();

  let dateObj = {};
  dateObj.fromDate = fdatefrom;
  dateObj.toDate = fdateto;

  return dateObj;
};
export const getYYYYMMFromTimestamp = (ts) => {
  let date = ts ? new Date(ts) : new Date();
  let year = date.getFullYear();
  let mon = date.getMonth() + 1;
  if (mon.toString().length < 2) {
    mon = "0" + mon;
  }

  return year + "-" + mon;
};
export const isJSON = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (err) {
    return false;
  }
};
export const getQueryParamByName = (name, url = window.location.href) => {
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
export const redirectToLink = (link) => {
  window.location.href = config[link];
}
export const getCustForTenant = () => {
  var  url = window.location.href;
  const hostname = new URL(url).hostname;

  if (hostname.includes("multicom")) {
    return "multicom";
  } else if (hostname.includes("sony")) {
    return "sony";
  } else if (hostname.includes("growthday")) {
    return "growthday";
  } else {
    return "cineverse";
  }
}
export const linkPushToHistory = (link, history,param) => {
  history.push(config[link]+(param ? param: ''));
}
export const getMessageForLevelValue = (level, name, msg, link, history,channel,platform,partner) => {
  var status = levelToStatus(level,link);
  // console.log(level+'----'+status);
  var param = '?status='+status;
  // if(!isUBN(channel) && channel !== 'all' && channel !== '') {
  //   param += '&channel='+channel;
  // }
  // if(!isUBN(platform) && platform !== 'all' && platform !== '') {
  //   param += '&platform='+platform;
  // }
  // if(!isUBN(partner) && partner !== 'all' && partner !== '') {
  //   param += '&partner='+partner;
  // }
  if (level >= 8) {
    return (
      <p className="jss180 pt10 p-b-10 p-l-5 p-r-5 oval-bg success-light-bg success-text">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span
              className="view-more-link"
              onClick={() => linkPushToHistory(link, history,param)}
            >
              details
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  } else if (level <= -8) {
    return (
      <p className="jss180 pt10 p-b-10 p-l-5 p-r-5 oval-bg danger-light-bg danger-text">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span
              className="view-more-link"
              onClick={() => linkPushToHistory(link, history,param)}
            >
              details
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  } else if (8 > level && level > 4) {
    return (
      <p className="jss180 p-l-5 p-r-5 success-text">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span
              className="view-more-link"
              onClick={() => linkPushToHistory(link, history,param)}
            >
              details
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  } else if (-8 < level && level < -4) {
    return (
      <p className="jss180 p-l-5 p-r-5 danger-text">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span
              className="view-more-link"
              onClick={() => linkPushToHistory(link, history,param)}
            >
              details
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  } else if (0 <= level && level <= 4) {
    return (
      <p className="jss180 p-l-5 p-r-5 text-black">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span
              className="view-more-link"
              onClick={() => linkPushToHistory(link, history,param)}
            >
              details
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  } else if (-3 >= level && level >= -4) {
    return (
      <p className="jss180 pt10 p-b-10 p-l-5 p-r-5 oval-bg warning-dark-bg warning-text">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span
              className="view-more-link"
              onClick={() => linkPushToHistory(link, history,param)}
            >
              details
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  } else if (level === -2) {
    return (
      <p className="jss180 pt10 p-b-10 p-l-5 p-r-5 oval-bg warning-medium-bg warning-text">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span
              className="view-more-link"
              onClick={() => linkPushToHistory(link, history,param)}
            >
              details
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  } else if (level === -1) {
    return (
      <p className="jss180 pt10 p-b-10 p-l-5 p-r-5 oval-bg warning-light-bg warning-text">
        <i
          className="fa fa-circle"
          aria-hidden="true"
          style={{ fontSize: 10 }}
        ></i>{" "}
        <b>{name}</b>
        {!isUBN(name) ? ` - ${msg}` : `${msg}`}
        {!isUBN(link) ? (
          <a href="/#"  onClick={(e) => {e.preventDefault();}}>
            ...
            <span className="view-more-link">
              <span
                className="view-more-link"
                onClick={() => linkPushToHistory(link, history,param)}
              >
                details
              </span>
            </span>
          </a>
        ) : (
          ""
        )}
      </p>
    );
  }
};

export const getPreMonthDate = (date) => {
  let endMonth = new Date();
  endMonth.setMonth(endMonth.getMonth(), endMonth.getDate() - 1);

    let _emmDDYYYY = endMonth.getFullYear() +
    '-' + (endMonth.getMonth() + 1 < 10
    ? '0' + (endMonth.getMonth() + 1)
    : endMonth.getMonth() + 1) +
    '-' +
    (endMonth.getDate() < 10
      ? '0' + (endMonth.getDate())
      : endMonth.getDate());
    
  let startMonth = new Date();
  startMonth.setMonth(startMonth.getMonth() - 1, startMonth.getDate() - 1);

    let _smmDDYYYY = startMonth.getFullYear() +
    "-" + (startMonth.getMonth() + 1 < 10
    ? '0' + (startMonth.getMonth() + 1)
    : startMonth.getMonth() + 1) +
  '-' +
  (startMonth.getDate() < 10
      ? '0' + (startMonth.getDate())
      : startMonth.getDate());

  let dateObj = {};
  dateObj.dateto = _emmDDYYYY;
  dateObj.datefrom = _smmDDYYYY;

  return dateObj;
};

export const valueInBadgeFromArr = (DataArr, wrap) => {
  let vals = [];
  if (Object.keys(DataArr).length > 0 && Array.isArray(DataArr)) {
    DataArr.forEach((data, i) => {
      const cdata =
        data && graphCodeObj[data]
          ? graphCodeObj[data].label
          : data
          ? data
          : "";
      let bdata = cdata ? (
        <Badge variant="secondary" key={i}>
          {cdata}
        </Badge>
      ) : (
        ""
      );
      vals.push(bdata);
    });
  }else{
    const cdata =
    DataArr && graphCodeObj[DataArr]
        ? graphCodeObj[DataArr].label
        : DataArr
        ? DataArr
        : "";
    let bdata = cdata ? (
      <Badge variant="secondary" key={0}>
        {cdata}
      </Badge>
    ) : (
      ""
    );
    vals.push(bdata);
  }
  if (wrap) {
    return <span className="cl-nowrap-only">{vals}</span>;
  } else {
    return vals;
  }
};

export const formatedArrValueCommaSeparated = (DataArr) => {
  let vals = [];
  if(Array.isArray(DataArr))
  {
    if (Object.keys(DataArr).length > 0 ) {
      DataArr.forEach((data, i) => {
        const cdata =
          data && graphCodeObj[data]
            ? graphCodeObj[data].label
            : data
            ? capitalizeFirstLetter(data)
            : "";
        vals.push(cdata);
      }); 
    }else{
      vals.push('');
    }
  }else{
    const cdata =
    DataArr && graphCodeObj[DataArr]
        ? graphCodeObj[DataArr].label
        : DataArr
        ? capitalizeFirstLetter(DataArr)
        : "";
    vals.push(cdata);
  }
  return vals.join(", ");
};

export const UrlExists = (url) => {
  let http = new XMLHttpRequest();
  http.open("HEAD", url, false);
  http.send();
  return http.status === 200;
};

export const imgError = (image) => {
  let noimg = NoLogo;
  image.onerror = "";
  image.src = noimg;
  return true;
};

export const downloadAsImgChart = (chartType,chartRef) => {
  let curDate = new Date();
  let a = document.createElement("a");
  a.href = chartRef.current.toBase64Image();
  a.download = chartType + curDate.getTime() + "_chart.png";
  a.click();   
};

export const downloadImageBar = async (chartFor,domEl,chartTitle,divTitle,splitBar) => {
  let blurDiv = document.createElement('div');
  blurDiv.id = "body-blurred-div";
  blurDiv.style.zIndex = 999;
  document.getElementById('main-body-component').appendChild(blurDiv);
  let childDiv = document.createElement('img');
  childDiv.id = splitBar ? "body-blurred-img-splitbar" :"body-blurred-img";
  childDiv.src = graphDownload;
  document.getElementById('body-blurred-div').appendChild(childDiv);
  const barGraphDiv = document.querySelector("#"+divTitle);
  const barGraphDivDownload = document.querySelector("#"+divTitle+"_download");
  barGraphDiv.style.display = "none";
  barGraphDivDownload.style.display = "block";
  let curDate = new Date();
  const dataUrl = await htmlToImage.toPng(domEl.current);   
  barGraphDiv.style.display = "block";
  barGraphDivDownload.style.display = "none";
  // download image
  const link = document.createElement('a');
  if(chartTitle) {
    link.download = chartTitle+".png";
  } else {
    link.download = chartFor + curDate.getTime() + "_chart.png";
  }    
  const element = document.getElementById("body-blurred-div");
  if(element) element.remove();  
  link.href = dataUrl;
  link.click();
}

export const downloadImage = async (chartFor,domEl,chartTitle,splitBar) => {
  // creating blur overlay
  let blurDiv = document.createElement('div');
  blurDiv.id = "body-blurred-div";
  blurDiv.style.zIndex = 999;
  document.getElementById('main-body-component').appendChild(blurDiv);
  let childDiv = document.createElement('img');
  childDiv.id = splitBar ? "body-blurred-img-splitbar" :"body-blurred-img";
  childDiv.src = graphDownload;
  document.getElementById('body-blurred-div').appendChild(childDiv);

  // download image
  let curDate = new Date();
  const dataUrl = await htmlToImage.toPng(domEl.current);
  const link = document.createElement('a');
  if(chartTitle) {
    link.download = chartTitle+".png";
  } else {
    link.download = chartFor + curDate.getTime() + "_chart.png";
  }    
  const element = document.getElementById("body-blurred-div");
  if(element) element.remove();  
  link.href = dataUrl;
  link.click();
}

export const downloadImageWithoutBlur = async (chartFor,domEl,chartTitle) => {
  // download image
  let curDate = new Date();
  const dataUrl = await htmlToImage.toPng(domEl.current);
  const link = document.createElement('a');
  if(chartTitle) {
    link.download = chartTitle+".png";
  } else {
    link.download = chartFor + curDate.getTime() + "_chart.png";
  }
  link.href = dataUrl;
  link.click();
}

export const downloadImageRibbon = async (chartFor,domEl,chartTitle,chartWidth,divTitle,splitBar) => {
  let blurDiv = document.createElement('div');
  blurDiv.id = "body-blurred-div";
  document.getElementById('main-body-component').appendChild(blurDiv);
  let childDiv = document.createElement('img');
  childDiv.id = splitBar ? "body-blurred-img-splitbar" :"body-blurred-img";
  childDiv.src = graphDownload;
  document.getElementById('body-blurred-div').appendChild(childDiv);
  const barGraphDiv = document.querySelector("#"+divTitle);
  barGraphDiv.style.width = (chartWidth)+"px";
  let curDate = new Date();
  const dataUrl = await htmlToImage.toPng(domEl.current); 
  barGraphDiv.style.width = '';
  // download image
  const link = document.createElement('a');
  if(chartTitle) {
    link.download = chartTitle+".png";
  } else {
    link.download = chartFor + curDate.getTime() + "_chart.png";
  }    
  const element = document.getElementById("body-blurred-div");
  if(element) element.remove();  
  link.href = dataUrl;
  link.click();
}

export const redirectToNewTab = (url) => {
  const win = window.open(
    url,
    '_blank' 
  );
  win.focus();
}

export const createDiagonalPattern = (color = 'black') => {
  let shape = document.createElement('canvas')
  shape.width = 10
  shape.height = 10
  let c = shape.getContext('2d')
  c.strokeStyle = color
  c.beginPath()
  c.moveTo(2, 0)
  c.lineTo(10, 8)
  c.stroke()
  c.beginPath()
  c.moveTo(0, 8)
  c.lineTo(2, 10)
  c.stroke()
  return c.createPattern(shape, 'repeat')
}
export const getPermissionStructure = (permissions) => {
  var permissionObj = {}
  Object.keys(permissions).forEach(key => {
    permissionObj[permissions[key].id] = permissions[key];
  });
  return permissionObj;
}
export const getPermission = (props, _id, perm) => {
  let _mp_jtv = {};
  let _mp_jtv_permission = {};
  if(cookie.load("umsLogin")) {
    _mp_jtv = localStorage.getItem('role_info') ? JSON.parse(localStorage.getItem('role_info')) : {};
    _mp_jtv = _mp_jtv.role_info;
    _mp_jtv_permission = getPermissionStructure(_mp_jtv && _mp_jtv.permissions ? _mp_jtv.permissions : {});
  } else {
    _mp_jtv = props.userpermission;
    _mp_jtv_permission = _mp_jtv && _mp_jtv.permission ? _mp_jtv.permission : {};
  }
  if (_mp_jtv_permission && Object.keys(_mp_jtv_permission).length > 0) {
    if (_mp_jtv_permission[_id]) {
      let _access = false;
      if (perm === "r" && _mp_jtv_permission[_id]["read"] === 1) {
        _access = true;
      } else if (perm === "w" && _mp_jtv_permission[_id]["write"] === 1) {
        _access = true;
      } else if (perm === "d" && _mp_jtv_permission[_id]["delete"] === 1) {
        _access = true;
      }
      return _access;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export const isSuperAdmin = () => {
  let isLogin = cookie.load('login');
  let userInfo = cookie.load(ConVar.authCookieName);
  let uname = !isUBN(userInfo) && isLogin && !isUBN(userInfo.email) ? userInfo.email : "";
  if (uname && (ConVar.superAdmin).includes(uname)) {
    return true;
  } else {
    return false;
  }
}

export const getQuarter = (date = new Date()) => {
  return "Q"+Math.floor(date.getMonth() / 3 + 1);
}

export const getSortedColor = (array,value,chartType) => {
  var done = false;
  while (!done) {
    done = true;
    for (var i = 1; i < array.length; i += 1) {
      if (array[i - 1] > array[i]) {
        done = false;
        var tmp = array[i - 1];
        array[i - 1] = array[i];
        array[i] = tmp;
      }
    }
  }
  var key = Object.keys(array).find(key => array[key] === value);
  if(chartType === 'quarterly')
  {
    return ConVar.quarterlyDoughnutColor[key];
  }
  else
  {
    return ConVar.yearlyDoughnutColor[key];
  }
  
};

export const getCacheBostVal = () => {
  let cacheBoost = Math.floor(Math.random() * 9999 + 1);
  return cacheBoost;
};

export const getChannelList = (props) => {
  let channelList = [];
  let chList = props.channels ? props.channels : [];
  if (chList && chList.length > 0) {
    chList.forEach((val) => {
      var optn = { value: val.id, label: val.name };
      channelList.push(optn);
    });
  }
  if (channelList) {
    channelList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return channelList;
}

export const getIngestionFrequencyChannelList = (props) => {
  let channelList = [];
  let chList = props.channels ? props.channels : [];
  channelList.push({ value: 'all', label: 'All' });
  if (chList && chList.length > 0) {
    chList.forEach((val) => {
      var optn = { value: val.id, label: val.name };
      channelList.push(optn);
    });
  }
  if (channelList) {
    channelList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return channelList;
}

export const getSVODChannelList = (props) => {
  let channelList = [];
  let chList = props.channels ? props.channels : [];
  if (chList && chList.length > 0) {
    chList.forEach((val) => {
      if(val.has_svod_ingestion_data) {
        var optn = { value: val.id, label: val.name };
        channelList.push(optn);
      }      
    });
  }
  if (channelList) {
    channelList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return channelList;
}
export const getLinearIngestionChannelList = (props,selectedStartDate,selectedEndDate) => {
  let channelList = [];
  let chList = props.channels ? props.channels : [];
  if (chList && chList.length > 0 ) {
    chList.forEach((val) => {
      var flag = true;
      if(val.has_linear_ingestion_data ) {        
        if(selectedStartDate && selectedEndDate) {
          const dateViewedStart = new Date(selectedStartDate*1000);
          const dateViewedEnd = new Date(selectedEndDate*1000);
          if(val.start_date) {
            const channelStartDate = new Date(val.start_date);
            if (channelStartDate.getTime() > dateViewedEnd.getTime()) {
              flag = false;
            }
          }
          if(val.end_date) {
            const channelEndDate = new Date(val.end_date);
            if (channelEndDate.getTime() < dateViewedStart.getTime()) {
              flag = false;
            }
          }
        }
        if(flag) {
          var optn = { value: val.id, label: val.name };
          channelList.push(optn);
        }
      }
    });
  }
  if (channelList) {
    channelList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return channelList; 
}

export const getCineverseHubChannelList = (props,selectedStartDate,selectedEndDate,subscription) => {
  let channelList = [];
  let chList = props.channels ? props.channels : [];
  if (chList && chList.length > 0 ) {
    chList.forEach((val) => {
      var flag = true;
      if(val.is_cineverse_hub && (!subscription || (subscription && val.has_svod_ingestion_data))) {        
        if(selectedStartDate && selectedEndDate) {
          const dateViewedStart = new Date(selectedStartDate*1000);
          const dateViewedEnd = new Date(selectedEndDate*1000);
          if(val.start_date) {
            const channelStartDate = new Date(val.start_date);
            if (channelStartDate.getTime() > dateViewedEnd.getTime()) {
              flag = false;
            }
          }
          if(val.end_date) {
            const channelEndDate = new Date(val.end_date);
            if (channelEndDate.getTime() < dateViewedStart.getTime()) {
              flag = false;
            }
          }
        }
        if(flag) {
          var optn = { value: val.id, label: val.name };
          channelList.push(optn);
        }
      }
    });
  }
  if (channelList) {
    channelList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return channelList; 
}

export const getOandOChannelList = (props,selectedStartDate,selectedEndDate,subscription) => {
  let channelList = [];
  let chList = props.channels ? props.channels : [];
  if (chList && chList.length > 0 ) {
    chList.forEach((val) => {
      var flag = true;
      if(val.owned_operated && !val.is_cineverse_hub  && (!subscription || (subscription && val.has_svod_ingestion_data))) {
        if(selectedStartDate && selectedEndDate) {
          const dateViewedStart = new Date(selectedStartDate*1000);
          const dateViewedEnd = new Date(selectedEndDate*1000);
          if(val.start_date) {
            const channelStartDate = new Date(val.start_date);
            if (channelStartDate.getTime() > dateViewedEnd.getTime()) {
              flag = false;
            }
          }
          if(val.end_date) {
            const channelEndDate = new Date(val.end_date);
            if (channelEndDate.getTime() < dateViewedStart.getTime()) {
              flag = false;
            }
          }
        }
        if(flag) {
          var optn = { value: val.id, label: val.name };
          channelList.push(optn);
        }
      }      
    });
  }
  if (channelList) {
    channelList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return channelList; 
}

export const getThirdPartyChannelList = (props,selectedStartDate,selectedEndDate,subscription) => {
  let channelList = [];
  let chList = props.channels ? props.channels : [];
  if (chList && chList.length > 0 ) {
    chList.forEach((val) => {
      var flag = true;
      if(!val.owned_operated && !val.is_cineverse_hub && (!subscription || (subscription && val.has_svod_ingestion_data))) {
        if(selectedStartDate && selectedEndDate) {
          const dateViewedStart = new Date(selectedStartDate*1000);
          const dateViewedEnd = new Date(selectedEndDate*1000);
          if(val.start_date) {
            const channelStartDate = new Date(val.start_date);
            if (channelStartDate.getTime() > dateViewedEnd.getTime()) {
              flag = false;
            }
          }
          if(val.end_date) {
            const channelEndDate = new Date(val.end_date);
            if (channelEndDate.getTime() < dateViewedStart.getTime()) {
              flag = false;
            }
          }
        }
        if(flag) {
          var optn = { value: val.id, label: val.name };
          channelList.push(optn);
        }
      }      
    });
  }
  if (channelList) {
    channelList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return channelList; 
}

export const getPlatformList = (props) => {
  let platformList = [];
  let pltfrmList = props.platforms ? props.platforms : [];
  if (pltfrmList && pltfrmList.length > 0) {
    pltfrmList.forEach((val) => {
      var optn = { value: val.id, label: val.name };
      platformList.push(optn);
    });
  }
  if (platformList) {
    platformList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return platformList;
}

export const getDailyPartnerList = (props) => {
  let partnerList = [];
  let uniquePartnerVAl = [];
  let digipartnrList = props.digitalPartners ? props.digitalPartners : [];
  if (digipartnrList && digipartnrList.length > 0) {
    digipartnrList.forEach((val) => {
      if(val.has_daily_data) {
        var optn = { value: val.id, label: val.name };
        partnerList.push(optn);
        uniquePartnerVAl.push(val.id);
      }        
    });
  }
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      if(val.has_daily_data) {
        if(!uniquePartnerVAl.includes(val.id)) {
          var optn = { value: val.id, label: val.name };
          partnerList.push(optn);
          uniquePartnerVAl.push(val.id);
        }
        
      }     
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getDailyOTTPartnerList = (props) => {
  let partnerList = [];  
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      if(val.has_daily_data) {
        var optn = { value: val.id, label: val.name };
        partnerList.push(optn);
      }  
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getDailyOTTSingleMetricPartnerList = (props) => {
  let partnerList = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      if(val.has_single_metric_report && val.has_daily_data) {
        var optn = { value: val.id, label: val.name };
        partnerList.push(optn);
      }
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getDailyOTTSubscriptionPartnerList = (props) => {
  let partnerList = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      if(val.has_daily_subscription_data) {
        var optn = { value: val.id, label: val.name };
        partnerList.push(optn);
      }      
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getHourlyOTTPartnerList = (props) => {
  let partnerList = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      if(val.from_hourly_ingestion_flag) {
        var optn = { value: val.id, label: val.name };
        partnerList.push(optn);
      }      
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getPartnerList = (props,metricReport) => {
  let partnerList = [];
  let uniquePartnerVAl = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      var optn = [];
      if(metricReport) {
        if(val.has_single_metric_report) {
          optn = { value: val.id, label: val.name };
          partnerList.push(optn);
          uniquePartnerVAl.push(val.id);
        }        
      }
      else {
        optn = { value: val.id, label: val.name };
        partnerList.push(optn);
        uniquePartnerVAl.push(val.id);
      }      
    });
  }
  let digipartnrList = props.digitalPartners ? props.digitalPartners : [];
  if (digipartnrList && digipartnrList.length > 0) {
    digipartnrList.forEach((val) => {
      if(!uniquePartnerVAl.includes(val.id)) {
        var optn = {};
        if(!metricReport) {
          if(val.has_monthly_data) {
            optn = { value: val.id, label: val.name };
            partnerList.push(optn);
          }
        }        
      }          
    });
  }
  if (partnerList) {
    partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return partnerList;
};

export const getNewPartnerList = (props,ingestionPartner) => {
  let partnerList = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      var optn = [];
      var flag=false;
      ingestionPartner.forEach(element => {
        if(element.partner === val.id && element.distribution_medium === 'ott') {
          flag = true;
        }
      });
      if(!flag) {
        optn = { value: val.id+"---OTT", label: val.name+" ( OTT )", dist_medium:"ott" };
        partnerList.push(optn); 
      }
    });
  }
  let digipartnrList = props.digitalPartners ? props.digitalPartners : [];
  if (digipartnrList && digipartnrList.length > 0) {
    digipartnrList.forEach((val) => {
      var optn = {};
      var flag=false;
      ingestionPartner.forEach(element => {
        if(element.partner === val.id && element.distribution_medium === 'digital') {
          flag = true;
        }
      });
      if(!flag) {
        optn = { value: val.id+"---Digital", label: val.name+" ( Digital )", dist_medium:"digital" };
        partnerList.push(optn); 
      }
    });
  }
  if (partnerList) {
    partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return partnerList;
};

export const getPartnerSubscriptionList = (props,metricReport) => {
  let partnerList = [];
  let uniquePartnerVAl = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      var optn = [];
      if(val.has_daily_subscription_data ) {
        optn = { value: val.id, label: val.name };
        partnerList.push(optn);
        uniquePartnerVAl.push(val.id);
      }
    });
  }
  if (partnerList) {
    partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return partnerList;
};

export const getMonthlyOTTPartnerList = (props,report) => {
  let partnerList = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      var optn = {};
      if(report) {
        if(!val.is_alias_partner) {
          optn = { value: val.id, label: val.name };
          partnerList.push(optn);
        }
      } else {
        optn = { value: val.id, label: val.name };
        partnerList.push(optn);
      }      
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getAdServersList = (props) => {
  let adServersList = [];
  let adSrvList = props.adServers ? props.adServers : [];
  if (adSrvList && adSrvList.length > 0) {
    adSrvList.forEach((val) => {
      var optn = { value: val.id, label: val.name };
      adServersList.push(optn);
    });
  }
  adServersList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return adServersList;
}

export const getMonthlyOTTPartnerSingleMetricList = (props) => {
  let partnerList = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      if(val.has_single_metric_report) {
        var optn = { value: val.id, label: val.name };
        partnerList.push(optn);
      }
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getMonthlyOTTPartnerContentWatchedList = (props,report) => {
  let partnerList = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      if(val.has_first_content_watch_data) {        
        var optn = {};
        if(report) {
          if(!val.is_alias_partner) {
            optn = { value: val.id, label: val.name };
            partnerList.push(optn);
          }
        } else {
          optn = { value: val.id, label: val.name };
          partnerList.push(optn);
        }
      }
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getDigitalPartnerList = (props,report) => {
  let partnerList = [];
  let digipartnrList = props.digitalPartners ? props.digitalPartners : [];
  if (digipartnrList && digipartnrList.length > 0) {
    digipartnrList.forEach((val) => {
      var optn = {};
      if(report) {
        if(!val.is_alias_partner) {
          optn = { value: val.id, label: val.name };
          partnerList.push(optn);
        }
      } else {
        optn = { value: val.id, label: val.name };
        partnerList.push(optn);
      }
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getMonthlyDigitalPartnerList = (props,report) => {
  let partnerList = [];
  let digipartnrList = props.digitalPartners ? props.digitalPartners : [];
  if (digipartnrList && digipartnrList.length > 0) {
    digipartnrList.forEach((val) => {
      if(val.has_monthly_data) {
        var optn = {};
        if(report) {
          if(!val.is_alias_partner) {
            optn = { value: val.id, label: val.name };
            partnerList.push(optn);
          }
        } else {
          optn = { value: val.id, label: val.name };
          partnerList.push(optn);
        }
      }
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getDailyDigitalPartnerList = (props,report) => {
  let partnerList = [];
  let digipartnrList = props.digitalPartners ? props.digitalPartners : [];
  if (digipartnrList && digipartnrList.length > 0) {
    digipartnrList.forEach((val) => {
      if(val.has_daily_data) {
        var optn = {};
        if(report) {
          if(!val.is_alias_partner) {
            optn = { value: val.id, label: val.name };
            partnerList.push(optn);
          }
        } else {
          optn = { value: val.id, label: val.name };
          partnerList.push(optn);
        }
      }
    });
  }
  partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return partnerList;
}

export const getLinearChannelMapSourceList  = (props) => {
  let partnerList = [];
  let uniquePartnerVAl = [];
  let partnrList = props.partners ? props.partners : [];
  if (partnrList && partnrList.length > 0) {
    partnrList.forEach((val) => {
      var optn = [];
      if(val.is_linear) {
        optn = { value: val.id, label: val.name };
        partnerList.push(optn);
        uniquePartnerVAl.push(val.id);
      }
    });
  }
  if (partnerList) {
    partnerList.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
  return partnerList;
};

export const getReportTemplateList = (data) => {
  let templateList = [];
  let tempList = data ? data : [];
  if (tempList && Object.keys(tempList).length > 0) {
    for (var temp in tempList) {
      var optn = { value: tempList[temp].id, label: tempList[temp].name, data:tempList[temp] };
      templateList.push(optn);
    }
  }
  templateList.sort((a, b) => (a.label > b.label ? 1 : -1));
  templateList.forEach((element,i) => {
    templateList[i]['index'] = i;
  });
  return templateList;
}


export const getRedbirdIngestion = (partner,digital,props) => {
  let redBirdIngestion = false;
  if(digital) {
    let digipartnrList = props.digitalPartners ? props.digitalPartners : [];
    if (digipartnrList && digipartnrList.length > 0) {
      digipartnrList.forEach((val) => {
        if(partner === val.id) {
          redBirdIngestion= val.from_redbird_ingestion;
        }          
      });
    }
  } else {
    let ottPartnerList = props.partners ? props.partners : [];
    if (ottPartnerList && ottPartnerList.length > 0) {
      ottPartnerList.forEach((val) => {
        if (partner === val.id) {
          redBirdIngestion = val.from_redbird_ingestion;
        }
      });
    }
  }

  return redBirdIngestion;
}


export const getDeptList = (data) => {
  let departmentList = [];
  let deptList = data ? data : [];
  if (deptList && Object.keys(deptList).length > 0) {
    for (var dept in deptList) {
      var optn = { value: dept, label: deptList[dept] };
      departmentList.push(optn);
    }
  }
  departmentList.sort((a, b) => (a.label > b.label ? 1 : -1));
  return departmentList;
}

export const getIndex = (list,id) => {
  var ind = 0;
  list.forEach((element,i) => {
    if(element.value === id) {
      ind = i
    }
  });
  return ind;
}

export const getChartTitle = (chartFor,ofor,tab) => {
  let chartTitle = '';
  let _ChartLabel = '';
  const graphTypeDropdown = ConVar.graphTypeDropdown;
  graphTypeDropdown.forEach(element => {
    if (chartFor === element.value) {
      _ChartLabel = capitalizeFirstLetter(!isUBN(chartFor) && element.label ? element.label : chartFor);
    }
  });
  if(tab === 2) {
    if(ofor === 'partner' || ofor === 'partners') {
      chartTitle = 'Channel-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'platform' || ofor === 'platforms') {
      chartTitle = 'Channel-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'channel' || ofor === 'channels') {     
      chartTitle = 'Platform-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'licensor' || ofor === 'licensor_names'|| ofor === 'licensor_name') {     
      chartTitle = 'Channel-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'viewertype' || ofor === 'viewer_types' || ofor === 'viewer_type' ) {     
      chartTitle = 'Channel-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'device_type' || ofor === 'device_types' || ofor === 'devicetype') {     
      chartTitle = 'Channel-wise Split Graph-'+_ChartLabel;
    }
  } else {
    if(ofor === 'partner' || ofor === 'partners') {
      chartTitle = 'Partner-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'platform' || ofor === 'platforms') {
      chartTitle = 'Platform-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'channel' || ofor === 'channels') {     
      chartTitle = 'Channel-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'licensor' || ofor === 'licensor_names' || ofor === 'licensor_name') {     
      chartTitle = 'Licensor-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'viewertype' || ofor === 'viewer_types' || ofor === 'viewer_type' ) {     
      chartTitle = 'Business Model-wise Split Graph-'+_ChartLabel;
    } else if (ofor === 'device_type' || ofor === 'device_types' || ofor === 'devicetype') {     
      chartTitle = 'Device Type-wise Split Graph-'+_ChartLabel;
    }
  }
  
  return chartTitle;
};

export const getLastActivity = (value) => {
  let date_1 = new Date(datetimeFromTimestamp(value));
  let date_2 = new Date();
  let difference = date_2.getTime() - date_1.getTime();
  let TotalDays = Math.round(difference / (1000 * 3600 * 24));
  if(TotalDays >= 0) {
    if(TotalDays <= 90) {
      return (
        <Tooltip title={"Last Logged in : "+datetimeFromTimestamp(value)} arrow placement={"top"}>
          <i className="fa fa-check-circle tick-icon-contacts">&nbsp;&nbsp;
            <span style={{color:"rgba(0, 0, 0, 0.5)",fontSize:"0.8rem"}}>{TotalDays === 0 ? "Today" : TotalDays === 1 ? TotalDays+" day ago" : TotalDays+" days ago" }</span>
          </i>          
        </Tooltip>
      );
    } else if(TotalDays > 90 && TotalDays <= 180 ) {  
      return (
        <Tooltip title={"Last Logged in : "+datetimeFromTimestamp(value)} arrow placement={"top"}>
          <i className="feather icon-orange-alert cursor-pointer">&nbsp;
            <span>{TotalDays+" days ago" }</span>
          </i> 
        </Tooltip>
      );
    } else {  
      return (
        <Tooltip title={"Last Logged in : "+datetimeFromTimestamp(value)} arrow placement={"top"}>
          <i className="feather icon-alert cursor-pointer">&nbsp;
            <span>{TotalDays+" days ago" }</span>
          </i> 
        </Tooltip>
      );
    }
  } else {
    return "";
  }  
};

export const valueFormatforChart = (value,chartFor) => {
  var dollarFormatArr = ["revenue","revenue_per_user","revenue_per_view","revenue_per_view_minute","ad_revenue","total_cost","cost_gb_streamed","cost_delivery","music_cost","gross_revenue","ad_rpm"];
  if(dollarFormatArr.includes(chartFor)) {
    return value ? valueToDollarFormat(value) : '$0.00';
  } else if(ConVar.withoutDecimal.includes(chartFor)) {
    return value ? USFormatWithoutDecimal(value) : '0'; 
  } else {
    return value ? numbersToUSFormat(value) : '0'; 
  }  
}
export const paramOption = (incldParam,paramArr,excludeParam) => {
  var newParamArr = []
  paramArr.forEach(element => {
    if(!excludeParam.includes(element)) {
      newParamArr.push({"value":element,"label":getSelectBoxPlaceHolder(element)})
    }    
  });
  // newParamArr.push({"value":incldParam,"label":getSelectBoxPlaceHolder(incldParam)})
  // console.log(newParamArr);
  return newParamArr;
}
export const getSelectBoxPlaceHolder = (param) => {
  let PlaceHolder = '';
    if(param === 'partner' || param === 'partners') {
      PlaceHolder = "Partners";
    } else if (param === 'platform' || param === 'platforms') {
      PlaceHolder = 'Platforms';
    } else if (param === 'channel' || param === 'channels') {     
      PlaceHolder = 'Channels';
    } else if (param === 'licensor' || param === 'licensor_names'|| param === 'licensor_name') {     
      PlaceHolder = 'Licensors';
    } else if (param === 'viewertype' || param === 'viewer_types' || param === 'viewer_type' ) {     
      PlaceHolder = 'Viewer Types';
    } else if (param === 'device_type' || param === 'device_types' || param === 'devicetype') {     
      PlaceHolder = 'Device Types';
    } else if (param === 'distribution_mediums' || param === 'distribution_medium' || param === 'distributionmedium') {     
      PlaceHolder = 'Distribution Mediums';
    } else if (param === 'distribution_type' || param === 'distribution_types' || param === 'distributiontype') {     
      PlaceHolder = 'Distribution Types';
    }
  
  return PlaceHolder;
};

export const checkDates  = (stDate,endDate) => {
  var date1 = new Date(stDate);
  var date2 = new Date(endDate);
  var Difference_In_Time = date2.getTime() - date1.getTime();
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  if(Difference_In_Days > 365) {
    return false;
  }
  return true;
}

export const getBanner  = (stDate,endDate) => {
  var url = ConURL.ajaxBaseUrl + ConURL.bannerUrl + 'get?days=7';
  httpGetRequest(url, function (response) {
    if (response && response.data && response.data.length > 0 ) {
      var bannerData = response.data;
      bannerData.forEach(element => {
        NotificationManager.info(element.desc,null,86400000);
      });
    }
  });
}

 export const getToken = (callback) => {
    var _url = ConURL.apiconsole + "/jtvtok/";
    var bodyFormData = new FormData();
    bodyFormData.append('custid', 'cinedigm');

    httpPostReqReg(
      _url,
      bodyFormData,
      function (resp) {
          if (
            resp !== undefined &&
            resp !== null &&
            resp !== "" && 
            !isUBN(resp.data)
          ) {
            if (
              resp.data.client_id !== undefined &&
              resp.data.client_id === ConVar.custid
            ) {
              if (resp.data.access_token !== undefined) {
                cookie.save("token", resp.data.access_token);
                if (callback !== undefined) {
                  callback(resp.data.access_token);
                }
              }
            }
          }
      },
      "application/json");
  }

export const mmddyyyyfromyyyymmdd = (date) => {
  var UTCdate = new Date(date);
  UTCdate.setUTCHours(12, 0, 0, 0);
  var dateMMDDYYYY = mmddyyFromUTCString(UTCdate,"-");
  return dateMMDDYYYY;
}

export const weekName = (label) => {
  if (label.indexOf("-") !== -1) {
    let week = label.split("-")[1].replace("W", "Week ");
    let year = label.split("-")[0];
    label = week + " - " + year;
  }
  return label;  
}

export function getMissingReportStatusColor(errorCode) {
  var _errorCode = parseInt(errorCode);
  if(_errorCode === -100) { // Missing 
    return '#ff9fa8';
  } else if(_errorCode === -90) { // Stopped
    return '#bcaaa4';
  } else if(_errorCode === 2) { // Expected Delay
    return '#d2bdfd';
  } else if(_errorCode === 0) { // Initialized
    return '#b2ebf2';
  } else if(_errorCode === 1) { // Queued
    return '#b2dfdb';
  } else if(_errorCode === 3) { // Processing
    return '#4db6ac';
  } else if(_errorCode === -5) { // Error Containing
    return '#ffccbc';
  } else if(_errorCode === -50) { // Ignored Items
    return '#bdc86d';
  } else if(_errorCode === 10) { // Completed
    return '#a0c3a0';
  } else if(_errorCode === -3) { // Parse Error
    return '#ffcc80';
  } else if(_errorCode === 200) { // Finalized
    return '#00ad00';
  } else if(_errorCode === -43) { // Unavailable
    return '#e0e0e0';
  } else {
    return "";
  }
}

export function getMetricAvailibilityColor(Code) {
  var _Code = parseInt(Code);
  if(_Code === 0) { // Present
    return '#CEFFB3';
  } else if(_Code === 1) { // Not Present
    return '#FFAEAE';
  } else if(_Code === 2) { // Calculated
    return '#BFDEFF';
  } else if(_Code === -1) { // Not Available
    return '#F5F5F5';
  } else {
    return "#F5F5F5";
  }
}

export function getMetricAvailibilityLabel(Code) {
  var _Code = parseInt(Code);
  if(_Code === 0) { // Present
    return 'Present';
  } else if(_Code === 1) { // Not Present
    return 'Not Present';
  } else if(_Code === 2) { // Calculated
    return 'Calculated';
  } else if(_Code === -1) { // Not Available
    return 'Not Available';
  } else {
    return "Not Available";
  }
}

export const getGraphObjLabel = (id,props) => {
  let graphDynamicColorObj = props && props.graphDynamicColorObj ? props.graphDynamicColorObj : [];
  var label = '';
  if(!isUBN(id)) {
    if(graphDynamicColorObj && Object.keys(graphDynamicColorObj).length > 0 && graphDynamicColorObj[id] && graphDynamicColorObj[id].name) {
      label = graphDynamicColorObj[id].name;
    } else if(ConVar.graphCodeObj[id] && ConVar.graphCodeObj[id].label){
      label = ConVar.graphCodeObj[id].label;
    } else {
      label = capitalizeFirstLetter(id);
    }
  }
  return label;
}

export const getGraphObjLabelArr = (arr,props) => {
  var resultArr = [];
  arr.forEach(element => {
    resultArr.push(getGraphObjLabel(element,props));
  });
  return resultArr;
}

export const getGraphObjColor = (id,props) => {
  let graphDynamicColorObj = props && props.graphDynamicColorObj ? props.graphDynamicColorObj : [];
  var color = '';
  if(!isUBN(id)) {
    if(graphDynamicColorObj && Object.keys(graphDynamicColorObj).length > 0 && graphDynamicColorObj[id] && graphDynamicColorObj[id].color_code) {
      color = graphDynamicColorObj[id].color_code;
    } else if(ConVar.graphCodeObj[id] && ConVar.graphCodeObj[id].color){
      color = ConVar.graphCodeObj[id].color;
    } else {
      color = getRandomColorCode();
    }
  }
  return color;
}

export const getGraphObjLogo = (id,props) => {
  let graphDynamicColorObj = props && props.graphDynamicColorObj ? props.graphDynamicColorObj : [];
  var logo = '';
  if(!isUBN(id)) {
    if(graphDynamicColorObj && Object.keys(graphDynamicColorObj).length > 0 && graphDynamicColorObj[id] && graphDynamicColorObj[id].logourl) {
      logo = graphDynamicColorObj[id].logourl;
    } else if(ConVar.graphCodeObj[id] && ConVar.graphCodeObj[id].logo){
      logo = ConVar.graphCodeObj[id].logo;
    }
  }
  return logo;
}

export const yyyymmtommyyyy = (date) => {
  var label = "";
  if(!isUBN(date)) {
    if (date.indexOf("-") !== -1) {
      let monthNum = date.split("-")[1].replace(/\b0+/g, "");
      monthNum = parseInt(monthNum);
      const yearNum = date.split("-")[0];
      label = (monthNum < 10 ? "0"+monthNum : monthNum) + "/" + yearNum;
    }    
  }
  return label;
}

export const yyyymmddtoMMddyyyy = (date) => {
  const [year, month, day] = date.split("-");
  const formattedDate = `${month}-${day}-${year}`;
  return formattedDate;
}

export const MMddyyyytoyyyymmdd = (date) => {
  const [month, day, year] = date.split("-");
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

export function formatDateYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getMinMaxDates(dataArray) {
  if (!dataArray || dataArray.length === 0) {
    return null;
  }

  let minDate = new Date(dataArray[0].name);
  let maxDate = new Date(dataArray[0].name);

  for (let i = 1; i < dataArray.length; i++) {
    const currentDate = new Date(dataArray[i].name);

    if (currentDate < minDate) {
      minDate = currentDate;
    }

    if (currentDate > maxDate) {
      maxDate = currentDate;
    }
  }

  return { minDate: formatDateYYYMMDD(minDate), maxDate: formatDateYYYMMDD(maxDate) };
}

export function getToDateOTTDaily(date,dateType) {
  var _toDate = new Date(date);
  _toDate.setUTCHours(12, 0, 0, 0);
  if(dateType === "week" || dateType === "weekly") {
    var dayOfWeek = _toDate.getDay();
    var differenceToSunday = (dayOfWeek === 0) ? 0 : 7 - dayOfWeek;
    _toDate = new Date(new Date(_toDate.getFullYear(), _toDate.getMonth(), (_toDate.getDate()+differenceToSunday) ));
    _toDate = yearmonthdateFromUnixTimestamp(_toDate.getTime() / 1000);
    return _toDate;
  } else if(dateType === "month" || dateType === "monthly") {
    _toDate = new Date(_toDate.getFullYear(), _toDate.getMonth()+1,0);
    _toDate = yearmonthdateFromUnixTimestamp(_toDate.getTime() / 1000);
    return _toDate;
  } else if(dateType === "year" ) {
    _toDate = new Date(_toDate.getFullYear(), 11,0);
    _toDate = yearmonthdateFromUnixTimestamp(_toDate.getTime() / 1000);
    return _toDate;
  } else if(dateType === "quarter") {
    _toDate = new Date(_toDate.getFullYear(), _toDate.getMonth()+1,0);
    _toDate = yearmonthdateFromUnixTimestamp(_toDate.getTime() / 1000);
    return _toDate;
  } else {
    return date;
  }
}

export function getQuarterFirstDatefromDate(date) {
  let month = date.getMonth();
  let qtr = Math.floor(month / 3) + 1; 
  const firstMonthOfQuarter = (qtr - 1) * 3;
  const firstDateOfQuarter = new Date(date.getFullYear(), firstMonthOfQuarter, 1);
  return firstDateOfQuarter;
}

export function GetBarColor(maxVal,currentValue,positive) {
  const green = "#00ff00";
  const white = "#ffffff";
  const red = "#ff0000";

  let startRGB = hexToRgb(white);
  let endRGB = hexToRgb(red);
  if(positive) {
    startRGB = hexToRgb(white);
    endRGB = hexToRgb(green);
  }
  currentValue = currentValue/100;

  const r = Math.round(startRGB.r + currentValue * (endRGB.r - startRGB.r));
  const g = Math.round(startRGB.g + currentValue * (endRGB.g - startRGB.g));
  const b = Math.round(startRGB.b + currentValue * (endRGB.b - startRGB.b));

  return rgbToHex(r, g, b);

  function hexToRgb(hex) {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');
    
    // Parse the three color components
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { r, g, b };
  }

  function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
  }
}

export function getProperName(name) {
  if(name === "viewer_type") {
    return "viewer type";
  }
  return name;
}

export function dateStructureChannelPerformance(date,dateType) {
  var _toDate = new Date(date*1000);
  if(dateType === "week" || dateType === "weekly") {
    var dayOfWeek = _toDate.getDay();
    var differenceToSunday = (dayOfWeek === 0) ? 0 : 7 - dayOfWeek;
    _toDate = new Date(_toDate.getFullYear(), _toDate.getMonth(), (_toDate.getDate()+differenceToSunday) );
    _toDate = yearmonthdateFromUnixTimestamp(_toDate / 1000);
    return _toDate;
  } else if(dateType === "month" || dateType === "monthly") {
    date = yearmonthFromUnixTimestamp(date);
  } else if(dateType === "year" ) {
    date = YearFromTimestamp(date);
  } else if(dateType === "quarter") {
    date = yearQuarterFromUnixTimestamp(date);
  } else {    
    date = yyyyFromTs(date);
  }
  return date;
}

export function getReportCategory(type) {
  var reportCategoryList = ConVar.reportCategoryOptions;
  var reportCategory = type;
  reportCategoryList.forEach(element => {
    if(element.value === type) {
      reportCategory = element.label;
    }
  });
  return reportCategory;
}

export function getLabelRankingParameter(type) {
  var RankingParameterList = ConVar.RankingParameterOption;
  var RankingParameter = '';
  RankingParameterList.forEach(element => {
    if(element.value === type) {
      RankingParameter = element.label;
    }
  });
  return RankingParameter;
}

export function getAvilibilityMetricLabel(val) {
  let NumValue = val;
  if(!isUBN(val)) {
    if(val === 0) {
      NumValue= "present";
    } else if(val === 1) {
      NumValue= "notPresent";
    } else if(val === 2) {              
      NumValue= "calculated";
    } else if(val === -1) {           
      NumValue= "notAvailable";              
    }
  } else {
    NumValue= "notAvailable"
  }
  return NumValue;
}

export function getAvilibilityMetricVal(val) {
  let NumValue = val;
  if(!isUBN(val)) {
    if(val === "present") {
      NumValue= 0;
    } else if(val === "notPresent") {
      NumValue= 1;
    } else if(val === "calculated") {              
      NumValue= 2;
    } else if(val === "notAvailable") {           
      NumValue= -1;              
    }
  } else {
    NumValue= "-1"
  }
  return NumValue;
}


export function getTopProgramColor(value,max,min) {
  // Normalize value to a 0-1 range
  const ratio = (value - min) / (max - min);
  // Hue: 0 (red) -> 60 (yellow) -> 120 (green)
  const hue = ratio * 120;
  return `hsl(${hue}, 70%, 80%)`; // Adjust lightness and saturation if needed
}

export const formatPercentageWithSign = (percentage) => {
  if (isUBN(percentage)) return "N/A";
  const sign = percentage > 0 ? "+" : "-";
  return `${sign}${decimalFixedToNum(Math.abs(percentage), 2)}%`;
};

export const formatMonth = (monthStr) => {
  if (!monthStr) return "";
  const [year, month] = monthStr.split("-");
  const date = new Date(parseInt(year), parseInt(month) - 1, 1);
  return date.toLocaleString("default", { month: "short" }) + "-" + year;
};

export const getPreviousMonth = (monthStr) => {
  if (!monthStr) return "";
  const [year, month] = monthStr.split("-").map(Number);
  const date = new Date(year, month - 1, 1);
  date.setMonth(date.getMonth() - 1);
  const prevYear = date.getFullYear();
  const prevMonth = (date.getMonth() + 1).toString().padStart(2, "0");
  return `${prevYear}-${prevMonth}`;
};

export const formatMetricName = (metricName) => {
  if (isUBN(metricName)) return "";
  return metricName.charAt(0).toUpperCase() + metricName.slice(1).replace(/_/g, " ");
};

export const formatMetricTitle = (metric) => {
  const titles = {
    revenue: "Revenue Earned",
    viewtime: "Minutes Viewed",
    views: "View Count",
    users: "User Count",
    ad_impressions: "Ad Impressions",
  };

  return (
    titles[metric] ||
    formatMetricName(metric)
  );
  
};
export function dateStructureCSV(date,dateType) {
  const [year, month, day] = date.split("-");
  var newDate = new Date((`${month}-${day}-${year}`));
  if(dateType === "week" || dateType === "weekly") {
    const dayNum = newDate.getUTCDay() || 7;
    newDate.setUTCDate(newDate.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(newDate.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil(((newDate - yearStart) / 86400000 + 1) / 7);
    date = "Week "+weekNo+": "+year;
  } else if(dateType === "month" || dateType === "monthly") {
    date = yearmonthFromUnixTimestamp(newDate/1000);
  } else if(dateType === "year" ) {
    date = YearFromTimestamp(newDate/1000);
  } else if(dateType === "quarter") {
    date = yearQuarterFromUnixTimestamp(newDate/1000);
  } else {    
    date = `${month}-${day}-${year}`;
  }
  return date;
}

export function yearmonthFromDate(date){
  let dateObj = date;
  if (typeof date === "string" && /^\d{4}-\d{2}$/.test(date)) {
    const [year, month] = date.split("-");
    dateObj = new Date(parseInt(year), parseInt(month) - 1, 1);
  }

  if (!dateObj || !(dateObj instanceof Date) || isNaN(dateObj)) {
    const now = new Date();
    return `${now.getFullYear()}-${(now.getMonth() + 1)
      .toString()
      .padStart(2, "0")}`;
  }

  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  return `${year}-${month}`;
};

export function getMonthsBetweenDates(startDateStr, endDateStr) {
  const result = [];
  const startDate = new Date(startDateStr);
  startDate.setHours(startDate.getHours() + 12);
  const endDate = new Date(endDateStr);
  endDate.setHours(endDate.getHours() + 12);

  startDate.setDate(2);
  endDate.setDate(2);

  while (startDate <= endDate) {
    const mm = String(startDate.getMonth() + 1).padStart(2, '0');
    const yyyy = startDate.getFullYear();
    result.push(`${yyyy}-${mm}`);

    startDate.setMonth(startDate.getMonth() + 1);
  }
  return result;
}

export function getYearsBetweenDates(startDateStr, endDateStr) {
  const result = [];
  const startDate = new Date(startDateStr);
  startDate.setHours(startDate.getHours() + 12);
  const endDate = new Date(endDateStr);
  endDate.setHours(endDate.getHours() + 12);

  startDate.setMonth(0, 1);
  endDate.setMonth(0, 1);

  while (startDate <= endDate) {
    const yyyy = startDate.getFullYear();
    result.push(`${yyyy}`);

    startDate.setFullYear(startDate.getFullYear() + 1);
  }
  return result;
}

export function getQuartersBetweenDates(startDateStr, endDateStr) {
  const result = [];
  const startDate = new Date(startDateStr);
  startDate.setHours(startDate.getHours() + 12);
  const endDate = new Date(endDateStr);
  endDate.setHours(endDate.getHours() + 12);

  const startMonth = Math.floor(startDate.getMonth() / 3) * 3;
  startDate.setMonth(startMonth, 1);
  endDate.setDate(1);

  while (startDate <= endDate) {
    const year = startDate.getFullYear();
    const quarter = Math.floor(startDate.getMonth() / 3) + 1;
    result.push(`${year}-Q${quarter}`);

    startDate.setMonth(startDate.getMonth() + 3);
  }
  return result;
}


export function getMonthlyData(dataArr,month,growth) {
  var flag= false;
  var value = '';
  dataArr.forEach(element => {
    if(element.month === month) {
      flag= true;
      value = growth ? (element && element.total_change && element.total_change.sub_active_paid_users ? element.total_change.sub_active_paid_users : "0.00%") : (element && element.value && element.value.sub_active_paid_users ? element.value.sub_active_paid_users : "0");
    }
  })
  if(!flag) {
    value = 'N/A';
  }
  return value;
}

export function getpartnerMappingType(partner,props) {
  let digitalPartner = props.digitalPartners ? props.digitalPartners : [];
  var mappingType= '';
  if(digitalPartner.length > 0) {
    digitalPartner.forEach(element => {
      if(element.id === partner) {
        mappingType = element.mapping_type ? element.mapping_type :"";
      }
    })
  }
  return mappingType;
}

export function formatAxisLabel(value){
  if (value >= 1000000000) {
    return (value / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (value >= 1000000) {
    return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (value >= 1000) {
    return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return value;
};

export function getDateForOTtDailyFilter(defaultDate,dateTypeValue,firstDate,format) {
  let dateValue = '';
  if(firstDate) {
    if(dateTypeValue === "day" || dateTypeValue === "daily") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(new Date(defaultDate).setHours(12,0,0,0)).setMonth(new Date(defaultDate).getMonth()-1)) : !isUBN(ConVar.globalFilter.dailyFromDate) ? (ConVar.globalFilter.dailyFromDate) : 0;
    } else if(dateTypeValue === "week" || dateTypeValue === "weekly") {
      if(!isUBN(defaultDate)) {
        var date = new Date(defaultDate);
        var d = new Date(date.getFullYear(), date.getMonth() - 3, date.getDate());
        var previousWeekMonday = new Date(d);
        previousWeekMonday.setDate(
          d.getDate() - d.getDay() + (d.getDay() === 0 ? -6 : 1) - 7
        );
        dateValue = previousWeekMonday;
      } else {
        dateValue = !isUBN(ConVar.globalFilter.dailyFromWeek) ? (ConVar.globalFilter.dailyFromWeek) : 0;
      }
    } else if(dateTypeValue === "month" || dateTypeValue === "monthly") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).getFullYear()-1, new Date(defaultDate).getMonth() - 1, '01') : !isUBN(ConVar.globalFilter.fromDate) ? (ConVar.globalFilter.fromDate) : 0;
    } else if(dateTypeValue === "year" || dateTypeValue === "yearly") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).getFullYear()-1, 0, '01') : !isUBN(ConVar.globalFilter.dailyFromYear) ? (ConVar.globalFilter.dailyFromYear) : 0;
    }else if(dateTypeValue === "quarter" || dateTypeValue === "quarterly") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).setFullYear(new Date(defaultDate).getFullYear() - 1)) : !isUBN(ConVar.globalFilter.dailyToQuarter) ? (ConVar.globalFilter.dailyToQuarter) : 0;
    } else {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).getFullYear()-1, new Date(defaultDate).getMonth() - 1, '01') : !isUBN(ConVar.globalFilter.fromDate) ? (ConVar.globalFilter.fromDate) : 0;
    }
  } else {
    if(dateTypeValue === "day" || dateTypeValue === "daily") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).setHours(12,0,0,0)) : !isUBN(ConVar.globalFilter.dailyToDate) ? (ConVar.globalFilter.dailyToDate) : 0;
    } else if(dateTypeValue === "week" || dateTypeValue === "weekly") {
      if(!isUBN(defaultDate)) {
        var _date = new Date(defaultDate);
        var lastSunday = new Date(_date);
        lastSunday.setDate(_date.getDate() - _date.getDay());
        dateValue = lastSunday;
      } else {
        dateValue = !isUBN(ConVar.globalFilter.dailyToWeek) ? (ConVar.globalFilter.dailyToWeek) : 0;
      }
    } else if(dateTypeValue === "month" || dateTypeValue === "monthly") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).getFullYear(), new Date(defaultDate).getMonth() ,'00') : !isUBN(ConVar.globalFilter.fromDate) ? (ConVar.globalFilter.fromDate) : 0;
    } else if(dateTypeValue === "year" || dateTypeValue === "yearly") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).getFullYear()+1, 0, '00') : !isUBN(ConVar.globalFilter.dailyToYear) ? (ConVar.globalFilter.dailyToYear) : 0;
    }else if(dateTypeValue === "quarter" || dateTypeValue === "quarterly") {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).setFullYear(new Date(defaultDate).getFullYear())) : !isUBN(ConVar.globalFilter.dailyFromQuarter) ? (ConVar.globalFilter.dailyFromQuarter) : 0;
    } else {
      dateValue = !isUBN(defaultDate) ? new Date(new Date(defaultDate).getFullYear(), new Date(defaultDate).getMonth() ,'00') : !isUBN(ConVar.globalFilter.fromDate) ? (ConVar.globalFilter.fromDate) : 0;
    }
  }
  if(format === "yyyymmdd") {
    dateValue = yearmonthdateFromUnixTimestamp(dateValue/1000);
  }

  return dateValue;
}

export function getDomainCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}

export function logoutUser() {
  const isUmsLogin = cookie.load("umsLogin");
  const cookiesToRemove = [
    "login",
    ConVar.authCookieName,
    "token",
    "umsLogin",
    "umsAuthToken",
    "umsIsLoggedIn",
    "umsLoginType"
  ];
  cookiesToRemove.forEach((name) => {
    cookie.remove(name);
    cookie.remove(name, { path: "/" });
  });
  window.history.replaceState(null, null, "/");
  if (isUmsLogin) {
    window.location.href = "/log-back-in";
  } else {
    window.location.href = "/login";
  }
}